import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
import {
  Form,
  Row,
  Col,
  Button,
  Card,
  Modal,
  Menu,
  Divider,
  Spin,
  Table,
  Tag,
  Input,
  message,
  Select,
  DatePicker,
  Upload,
  Radio,
  Checkbox,
  Popconfirm,
  Typography,
  notification,
  TimePicker,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import {
  ArrowLeftOutlined,
  CloseOutlined,
  EditOutlined,
  CheckOutlined,
  DeleteOutlined,
  CameraOutlined,
} from "@ant-design/icons";
import FormItem from "antd/lib/form/FormItem";
import companylogo from "../../Images/companylogo.png";
import Iconuser from "../../Images/iconuser.png";
import Iconmail from "../../Images/Iconmail.png";
import Iconphone from "../../Images/Iconphone.png";
import Iconlocation from "../../Images/Iconlocation.png";
import Amplify, { Storage } from "aws-amplify";
import awsConfigure from "../../Config/AwsConfig";
import AppConfigs from "../../Config/AppConfig";
import { getDetails, update, list } from "../../api/Apis";
import moment from "moment";
import priceFormate, { formatPhoneNumber } from "../commonFunctions";
import PushToCarrier from "../../Components/PushToCarrier";
import AssignToCarrier from "../../Components/AssignToCarrier";
import LoadDelivered from "../../Components/LoadDelivered";
import GeneratePdf from "../../Components/GeneratePdf";
import NumberFormat from "react-number-format";
import RequestCarriersList from "../../Components/RequestCarriersList";
import profileAvatar from "../../Images/profileAvatar.png";
import ImageGallery from "../../Components/Common/ImageGallery";
import MapDirection from "./MapDirection";
import ErrorPage from "../ErrorPage";
import Docsample from "../../Images/pdf.jpg";
import ResizableAntdTable from "resizable-antd-table";
import "./LoadDetails.css";

Amplify.configure(awsConfigure);
const { Option } = Select;
const { Text } = Typography;

var rad = function (x) {
  return (x * Math.PI) / 180;
};

var getDistance = function (p1, p2) {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(p2.lat - p1.lat);
  var dLong = rad(p2.lng - p1.lng);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(p1.lat)) *
      Math.cos(rad(p2.lat)) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d * 0.000621371192; // returns the distance in meter
};
const dateFormat = "MM/DD/YYYY";

const dummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

function beforeUpload(file) {
  const isJpgOrPng =
    file.type === "image/jpeg" ||
    file.type === "image/png" ||
    file.type === "application/pdf";
  if (!isJpgOrPng) {
    notification["error"]({
      message: "You can only upload JPG/PNG file!",
    });
  }
  const isLt10M = file.size / 1024 / 1024 < 10;
  if (!isLt10M) {
    notification["error"]({
      message: "Image should be smaller than 10MB!",
    });
  }
  return isJpgOrPng && isLt10M;
}

class LoadDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
      rateModalStatus: false,
      rateModal: false,
      leadData: {},
      customerData: {},
      searchValue: "",
      dataSource: [],
      carriers: [],
      existingSelectedCarrier: "",
      rateValue: "",
      callForRate: false,
      productModal: false,
      productUpdateLoading: false,
      productsData: [],
      selectedProduct: {},
      startValue: "",
      endValue: "",
      deliveryEdit: false,
      locationEdit: false,
      locations: [],
      notesEdit: false,
      defeoNotesEdit: false,
      confirmModal: false,
      productLocations: [],
      masterData: [],
      locationEditPickup: false,
      pickupLocation: [],
      tagsEdit: false,
      rateEdit: false,
      uploadCompanyLogoLoading: false,
      delImage: "",
      callForRateValue: false,
      openCarrier: "no",
      carrierRequestsModalStatus: false,
      imageLoading1: false,
      imageLoading2: false,
      imageLoading3: false,
      imageLoading4: false,
      ticketEdit: false,
      gWeightEdit: false,
      tWeightEdit: false,
      pickupLocationEdit: false,
      updatedLoaction: "",
      EndTime: "",
      startTime: "",
      productIndex: 0,
      load_old_price: 0,
      showDeliveryModal: false,
      uploadPicLoading3: false,
      uploadPicLoading4: false,
      AuditDetails: [],
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      deliveryNotesEdit: false,
      bolModal: false,
      allUserList: [],
      subUserList: [],
    };
  }

  componentDidMount() {
    let search = new URLSearchParams(this.props.location.search);
    let openCarrier = search.get("openCarrier");
    this.setState({
      loading: false,
      dataLoadingStatus: true,
      openCarrier,
      orderDocument: "",
    });
    this.getCategoriesAndSubCategories(
      "carrierTag",
      "subCategoriesDataLoading"
    );

    this.getAuditTrailsDetails();
  }

  getCategoriesAndSubCategories = (dataType, loadingVariable) => {
    let query = {
      dataType: dataType,
      recordStatus: true,
    };
    list(AppConfigs["entityNames"]["masterData"], query).then((result) => {
      if (result.success) {
        let masterData = result.data;
        this.setState({
          masterData: masterData,
        });
        this.getLeadData();
      } else {
        console.log(result.errors);
      }
      this.setState({
        dataLoading: false,
      });
    });
  };

  getLeadData = () => {
    getDetails(
      AppConfigs["entityNames"]["leads"],
      this.props.match.params.id
    ).then(async (result) => {
      if (result.success) {
        let leadData = result.data;
        if (result.data.cartItems[0]?.orderDocument) {
          let image = await Storage.get(
            result.data.cartItems[0]?.orderDocument
          );
          this.setState({
            orderDocument: image,
          });
        }

        let productLocations = [];
        if (leadData["productOrigins"]) {
          productLocations = this.state.orgDetails["yardLocations"]?.filter(
            (loc) => leadData["productOrigins"].indexOf(loc.id) > -1
          );
        }
        if (result.data["orderStatus"] === AppConfigs["NEW"]) {
          let data = {
            entityData: {
              orderStatus: AppConfigs["PENDING"],
            },
          };
          update(
            AppConfigs["entityNames"]["leads"],
            this.props.match.params.id,
            data
          ).then((result) => {
            if (result.success) {
              leadData = result.data;
            } else {
              console.log(result.errors);
            }
          });
        }
        let tagNames = [];
        leadData["tags"] &&
          leadData["tags"].map((tag) => {
            tagNames.push(
              this.state.masterData.filter((t) => t.id === tag)[0]["name"]
            );
            leadData["tagNames"] = tagNames;
            return tag;
          });

        this.setState({
          leadData: leadData,
          productLocations: productLocations,
          rateValue: leadData["rateValue"] ? leadData["rateValue"] : "",
          callForRate: leadData["callForRate"]
            ? leadData["callForRate"]
            : false,
        });
        let deliveryImage = "";
        let deliveryTicket = "";
        if (this.state.leadData["leadDeliveryImage"]) {
          if (this.state.leadData["leadDeliveryImage"]?.delivery_pic !== "") {
            deliveryImage = await Storage.get(
              this.state.leadData["leadDeliveryImage"]?.delivery_pic
            );
          }
          if (
            this.state.leadData["leadDeliveryImage"]?.delivery_ticket_pic !== ""
          ) {
            deliveryTicket = await Storage.get(
              this.state.leadData["leadDeliveryImage"]?.delivery_ticket_pic
            );
          }
        }
        this.setState({
          delImage: deliveryImage,
          delTicket: deliveryTicket,
          uploadCompanyLogoLoading: false,
        });

        // let imagepath = await Storage.get(this.state.leadData['leadDeliveryImage']);
        // deliveryImage.push({ "deliveredImage": imagepath })
        // this.setState({
        //     deliveryImage: imagepath,
        // })

        getDetails(
          AppConfigs["entityNames"]["registrations"],
          result.data["customerId"]
        ).then(async (customerRes) => {
          if (customerRes.success) {
            let allUserList = [];
            let subUserList = [];
            let customerAdmin = {
              id: customerRes.data["id"],
              email: customerRes.data["email"],
            };
            allUserList.push(customerAdmin);
            if (customerRes.data["users"]) {
              subUserList = customerRes.data["users"].filter(
                (item) => item.email !== customerRes.data["email"]
              );
            }
            allUserList = [customerAdmin, ...subUserList];
            if (customerRes["data"]["companyLogo"]) {
              customerRes["data"]["companyLogo"] = await Storage.get(
                customerRes["data"]["companyLogo"]
              );
            }
            let locations = [];
            customerRes.data["customerLocations"] &&
              customerRes.data["customerLocations"].map((location, index) => {
                let address = location["location"]; // + "," + location["address"] + "," + location["city"] + "," + location["state"] + "," + location["pincode"];
                return locations.push(address);
              });
            this.setState({
              locations: locations,
              dataLoadingStatus: false,
              customerData: customerRes.data,
              subUserList,
              allUserList,
            });
          } else {
            this.setState({
              dataLoadingStatus: false,
            });
          }
        });
      } else {
        console.log(result.errors);
        this.setState({
          dataLoadingStatus: false,
        });
      }
    });
  };

  getAuditTrailsDetails = () => {
    list("auditTrail", {
      typeofPage: "orderDetails",
      recordId: this.props.match.params.id,
    })
      .then((details) => {
        if (details.success) {
          let totalAudit = details.data.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : -1
          );
          totalAudit = details.data.map((eachAudit) => {
            const uniqueAudit = this.removeDup(
              eachAudit.auditTrailDetails,
              "changedFieldName"
            );
            eachAudit["auditTrailDetails"] = uniqueAudit;
            return eachAudit;
          });
          this.setState({
            auditDetails: totalAudit,
          });
        }
      })
      .catch((err) => console.log(err, "errrrr"));
  };

  onChange(date, dateString) {
    console.log(date, dateString);
  }

  setEndValue = (value, id) => {
    if (!value) {
      if (
        this.props.form.getFieldValue("deliveryStartTime") >
        this.props.form.getFieldValue(id)
      ) {
        message.error("Please select valid time");
        this.props.form.setFieldsValue({
          [id]: null,
        });
        return;
      } else {
        this.props.form.setFieldsValue({
          [id]: this.props.form.getFieldValue(id),
        });
      }
    }
  };

  selectProduct = (productId) => {
    this.setState({
      loading: true,
    });
    let selectedProduct = this.state.productsData.filter(
      (product) => product.id === productId
    );
    this.setState({
      selectedProduct: selectedProduct[0],
      pageLoading: false,
    });
    this.props.form.setFieldsValue({
      size: "",
      quantity: 0,
      measurementType: "",
      deliveryTruck: "",
      amount: "",
    });
  };

  deliveryEdit = async () => {
    await this.setState({
      deliveryEdit: true,
    });
    const dataSource = this.state.leadData;
    let deliveryReqTime = this.state.leadData["deliveryReqTime"].split(" - ");
    this.props.form.setFieldsValue({
      deliveryDate: moment(dataSource["deliveryReqDate"], "MM/DD/YYYY"),
      deliveryStartTime: moment(deliveryReqTime[0], "hh:mm A"),
      deliveryEndTime: moment(deliveryReqTime[1], "hh:mm A"),
    });
  };

  updateDeliveryEdit = () => {
    this.setState({
      dataLoadingStatus: true,
    });
    this.props.form.validateFieldsAndScroll(
      ["deliveryDate", "deliveryStartTime", "deliveryEndTime"],
      async (err, values) => {
        if (!err) {
          let leadData = this.state.leadData;
          let cartItems = leadData["cartItems"];

          cartItems[0]["deliveryReqDate"] = moment(
            values["deliveryDate"]
          ).format("MM/DD/YYYY");
          cartItems[0]["deliveryReqTime"] =
            moment(values["deliveryStartTime"]).format("hh:mm A") +
            " - " +
            moment(values["deliveryEndTime"]).format("hh:mm A");
          // cartItems[0]["poNumber"] = values["poNumber"];
          // cartItems[0]["locationName"] = values["location"];
          let data = {
            entityData: {
              deliveryReqDate: moment(values["deliveryDate"]).format(
                "MM/DD/YYYY"
              ),
              deliveryReqTime:
                moment(values["deliveryStartTime"]).format("hh:mm A") +
                " - " +
                moment(values["deliveryEndTime"]).format("hh:mm A"),
              estimatedDeliveryDate: moment(values["deliveryDate"]).format(
                "MM/DD/YYYY"
              ),
              estimatedDeliveryTime:
                moment(values["deliveryStartTime"]).format("hh:mm A") +
                " - " +
                moment(values["deliveryEndTime"]).format("hh:mm A"),
              cartItems,
            },
          };
          this.setState({
            deliveryEdit: false,
          });
          await this.updateRecord(
            data,
            this.props.match.params.id,
            "Date update Successfully"
          );
        }
      }
    );
  };

  locationEdit = async (location) => {
    await this.setState({
      locationEdit: true,
    });
    this.props.form.setFieldsValue({
      customerLocation: location,
    });
  };

  updateLocationEdit = async () => {
    this.setState({
      dataLoadingStatus: true,
    });
    let distance = 0;
    let selectedCustomerLocation =
      this.state.customerData.customerLocations.filter(
        (location) =>
          location.location ===
          this.props.form.getFieldValue("customerLocation")
      );
    if (
      "productOriginDetails" in this.state.leadData &&
      "latLng" in selectedCustomerLocation[0]
    ) {
      let customerLatLangs = selectedCustomerLocation[0]["latLng"];
      let productOrigins = this.state.leadData["productOriginDetails"];
      if ("latLng" in productOrigins) {
        let findDistance = await getDistance(
          customerLatLangs,
          productOrigins["latLng"]
        );
        distance = findDistance;
      }
    }

    let cartItems = this.state.leadData["cartItems"];
    cartItems[0]["locationName"] = selectedCustomerLocation[0]["location"];
    cartItems[0]["address"] = selectedCustomerLocation[0]["address"];
    let data = {
      entityData: {
        customerLatLng: selectedCustomerLocation[0]["latLng"],
        distanceMiles: distance.toFixed(2),
        cartItems: cartItems,
      },
    };
    await this.updateRecord(
      data,
      this.props.match.params.id,
      "Location update Successfully"
    );
  };

  pickupLocationEdit = async (locationName) => {
    await this.setState({
      locationEditPickup: true,
    });
    this.props.form.setFieldsValue({
      pickupLocation: locationName,
    });
  };

  updateNotesEdit = async (type) => {
    let notes = this.props.form.getFieldValue("customerNotes");
    let defeoNotes = this.props.form.getFieldValue("defeoNotes");
    let deliveryNotes = this.props.form.getFieldValue("deliveryNotes");
    if (type === "defeoNotes" && !defeoNotes) {
      message.error("Please input Order notes !");
      return;
    }
    if (type === "customerNotes" && !notes) {
      message.error("Please input PickUp Notes!");
      return;
    }
    if (type === "deliveryNotes" && !deliveryNotes) {
      message.error("Please input Delivery Notes!");
      return;
    }
    let leadData = this.state.leadData;
    if (defeoNotes) {
      leadData["cartItems"][0]["defeoNotes"] = defeoNotes;
    }
    let carrierDetails;
    if (deliveryNotes) {
      carrierDetails = {
        carrierName: leadData["carrierDetails"]?.["carrierName"],
        carrierNotes: deliveryNotes && deliveryNotes,
      };
    }
    let data = {
      entityData: {
        notes: notes,
        carrierDetails,
        cartItems: leadData["cartItems"],
      },
    };
    await this.updateRecord(
      data,
      this.props.match.params.id,
      "Notes update Successfully"
    );
  };

  updateTags = async () => {
    let tags = this.props.form.getFieldValue("tags");
    let data = {
      entityData: {
        tags: tags,
      },
    };
    await this.updateRecord(
      data,
      this.props.match.params.id,
      "Tags update Successfully"
    );
  };

  updateRates = async () => {
    let rateValue = this.props.form.getFieldValue("rateValue");
    let data = {
      entityData: {
        rateValue: rateValue,
      },
    };
    await this.updateRecord(
      data,
      this.props.match.params.id,
      "Rate update Successfully"
    );
  };
  removeDup = (data, key) => {
    var check = new Set();
    return data.filter((obj) => !check.has(obj[key]) && check.add(obj[key]));
  };

  handleDeliveredImageChange = async (fileData) => {
    // e.preventDefault();
    this.setState({
      uploadCompanyLogoLoading: true,
    });
    let file = fileData["file"]["originFileObj"];
    let leadData = this.state.leadData;
    // let fileName = leadData["id"] + "_lead_delivery_pic_" + file["name"];
    let fileName =
      leadData["subOrderId"] + "_lead_delivery_pic_" + file["name"];
    await Storage.put(fileName, file, {
      contentType: file.type,
    }).then((result) => {
      let data = {};
      data["entityData"] = {};
      data["entityData"]["leadDeliveryImage"] = result.key;
      update(
        AppConfigs["entityNames"]["leads"],
        this.state.leadData["id"],
        data
      ).then(async (result) => {
        if (result.success) {
          leadData["leadDeliveryImage"] =
            data["entityData"]["leadDeliveryImage"];
          this.getLeadData();
        } else {
          this.setState({
            uploadCompanyLogoLoading: false,
          });
          console.log(result.errors);
        }
      });
    });
  };

  productModal = async (id) => {
    const dataSource = this.state.leadData["cartItems"]
      ? this.state.leadData["cartItems"]
      : this.state.leadData["items"];
    const productData = dataSource.filter((p) => p.id === id && p);
    let index = dataSource.findIndex((x) => x.id === id);
    await this.getProductsData(
      productData[0]["productId"],
      productData[0]["measurementType"],
      index
    );
    this.setState({ productIndex: index });
    this.props.form.setFieldsValue({
      productName: productData[0]["productName"],
      size: productData[0]["size"],
      quantity: productData[0]["quantity"],
      measurementType: productData[0]["measurementType"],
      deliveryTruck: productData[0]["deliveryTruck"],
      amount: productData[0]["amount"] * productData[0]["quantity"],
    });
    this.setState({
      productUpdateLoading: false,
      productModal: true,
    });
  };

  getProductsData = (productId, type) => {
    let customerId = this.state.leadData["customerId"];

    list(AppConfigs["getCustomerProducts"] + "/" + customerId, {}).then(
      (result) => {
        if (result.success) {
          let selectedProduct = {};
          let data = [];
          let filterData;
          if (type === "Pallet") {
            data = result.data["Palletized Stone"];
            filterData = data.filter((product) => product.id === productId);
            if (filterData.length > 0) {
              selectedProduct = filterData[0];
            }
          } else {
            data = result.data["Bulk Gravel"];
            filterData = data.filter((product) => product.id === productId);
            if (filterData.length > 0) {
              selectedProduct = filterData[0];
            }
          }

          this.setState({
            pageLoading: false,
            productsData: data.sort((a, b) =>
              a["productName"] > b["productName"] ? 1 : -1
            ),
            selectedProduct: selectedProduct,
          });
        } else {
          console.log(result.errors);
          this.setState({
            pageLoading: false,
          });
        }
      }
    );
  };

  changeFiled = (value, id) => {
    let ids = ["size", "quantity", "measurementType"];
    let isEmpty = true;
    let data = {};
    data[id] = value;
    ids
      .filter((i) => i !== id)
      .map((i) => {
        if (
          !this.props.form.getFieldValue(i) ||
          this.props.form.getFieldValue(i) === ""
        ) {
          isEmpty = false;
        } else {
          data[i] = this.props.form.getFieldValue(i);
        }
        return i;
      });
    if (isEmpty) {
      let sizeInfo = this.state.selectedProduct.sizes.filter(
        (size) => size.size === data["size"]
      );
      let amount = sizeInfo[0][data["measurementType"].toLowerCase()]
        ? sizeInfo[0][data["measurementType"].toLowerCase()]
        : 0;
      this.props.form.setFieldsValue({
        amount: amount * data["quantity"],
      });
    }
  };

  openRateModal = (id) => {
    this.props.form.setFieldsValue({
      rateValue: "",
    });

    this.setState({
      recordId: id,
      pushCarrierLoadingStatus: false,
      rateModalStatus: true,
      rateErrorMsg: "",
    });
  };

  closeRateModel = () => {
    this.setState({
      rateModal: false,
      loading: false,
    });
    window.location.reload();
  };

  orderConfirm = async (orderType) => {
    let selectedLocation =
      this.state.productLocations && this.state.productLocations[0];

    let distanceMiles = null;
    if (
      "customerLatLng" in this.state.leadData &&
      this.state.leadData["customerLatLng"]
    ) {
      let customerLatLangs = this.state.leadData["customerLatLng"];
      if (selectedLocation) {
        distanceMiles = await getDistance(
          customerLatLangs,
          selectedLocation?.["latLng"]
        );
        distanceMiles = distanceMiles.toFixed(2);
      }
    }
    let data = {
      entityData: {
        productOriginDetails: selectedLocation,
        distanceMiles: distanceMiles,
        orderStatus: AppConfigs["ORDER_PROCESSED"],
        orderProcessedTime: moment().valueOf(),
        estimatedDeliveryDate: this.state.leadData["deliveryReqDate"],
        estimatedDeliveryTime: this.state.leadData["deliveryReqTime"],
      },
    };
    await this.updateRecord(
      data,
      this.props.match.params.id,
      "Order confirm Successfully"
    );
  };

  updateProduct = () => {
    this.props.form.validateFieldsAndScroll(
      [
        "productName",
        "size",
        "quantity",
        "measurementType",
        "amount",
        "deliveryTruck",
      ],
      async (err, values) => {
        if (!err) {
          const { productIndex } = this.state;
          if (
            values["measurementType"] === "Truckload" &&
            parseInt(values["quantity"]) > 1
          ) {
            message.error("Only 1 truckload can be ordered at a time.");
            return;
          } else if (parseInt(values["quantity"]) === 0) {
            message.error("Please select valid quantity.");
            return;
          } else if (
            values["measurementType"] === "Pallet" &&
            values["amount"] === 0
          ) {
            message.error(
              "This product is currently not available by the pallet"
            );
            return;
          } else if (
            values["measurementType"] === "Truckload" &&
            values["amount"] === 0
          ) {
            message.error(
              "This product is currently not available by the truckload"
            );
            return;
          }
          this.setState({
            productUpdateLoading: true,
            // productModal: false
          });
          let leadData = this.state.leadData;
          delete leadData["id"];
          delete leadData["orderStatus"];
          leadData["locationName"] = leadData["location"];
          leadData["cartItems"] = leadData["cartItems"]
            ? leadData["cartItems"]
            : leadData["items"];
          delete leadData["location"];
          delete leadData["items"];
          delete leadData["updatedAt"];
          let distance = 0,
            productOriginDetails = {};
          let selectedCustomerLocation =
            this.state.customerData.customerLocations.filter(
              (location) =>
                location.location === leadData["cartItems"][0]["locationName"]
            );
          const orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
          if (
            "productOrigin" in this.state.selectedProduct &&
            selectedCustomerLocation.length > 0 &&
            "latLng" in selectedCustomerLocation[0]
          ) {
            let customerLatLangs = selectedCustomerLocation[0]["latLng"];
            let productOrigins = orgDetails.yardLocations.filter(
              (location) =>
                this.state.selectedProduct.productOrigin.indexOf(location.id) >
                -1
            );
            await productOrigins.map(async (lo, index) => {
              if ("latLng" in lo) {
                let findDistance = await getDistance(
                  customerLatLangs,
                  lo["latLng"]
                );
                if (index === 0 || distance > findDistance) {
                  distance = findDistance;
                  productOriginDetails = lo;
                }
              }
              return lo;
            });
          }

          let totalAmt = 0;
          if (values["deliveryTruck"] === "OpenTop") {
            totalAmt = parseFloat(values["amount"]) * 110;
          } else if (values["deliveryTruck"] === "GondolaRailcar") {
            totalAmt = parseFloat(values["amount"]) * 99;
          } else if (values["measurementType"] === "Pallet") {
            totalAmt = parseFloat(values["amount"]);
          } else {
            totalAmt = parseFloat(values["amount"]) * 24;
          }
          leadData["oldLoadAmount"] = this.state.load_old_price;
          leadData["productName"] = this.state.selectedProduct["productName"];
          leadData["productOriginDetails"] = productOriginDetails;
          leadData["size"] = values["size"];
          leadData["quantity"] =
            leadData["measurementType"] === "Pallet" ? values["quantity"] : 1;
          leadData["measurementType"] =
            leadData["measurementType"] === "Pallet"
              ? values["measurementType"]
              : "Truckload";
          leadData["totalAmt"] = totalAmt;
          leadData["distanceMiles"] = distance.toFixed(2);
          leadData["cartItems"][productIndex]["productId"] =
            this.state.selectedProduct["id"];
          leadData["cartItems"][productIndex]["productName"] =
            this.state.selectedProduct["productName"];
          leadData["cartItems"][productIndex]["productOrigin"] =
            productOriginDetails;
          leadData["cartItems"][productIndex]["size"] = values["size"];
          leadData["cartItems"][productIndex]["quantity"] =
            leadData["measurementType"] === "Pallet" ? values["quantity"] : 1;
          leadData["cartItems"][productIndex]["measurementType"] =
            leadData["measurementType"] === "Pallet"
              ? values["measurementType"]
              : "Truckload";
          leadData["cartItems"][productIndex]["amount"] =
            leadData["measurementType"] === "Pallet"
              ? leadData["cartItems"][0]["amount"]
              : values["amount"];

          leadData["cartItems"][productIndex]["totalAmt"] = totalAmt;
          leadData["cartItems"][productIndex]["deliveryTruck"] =
            values["deliveryTruck"];
          let data = {
            entityData: leadData,
          };
          await this.updateRecord(
            data,
            this.props.match.params.id,
            "Load updated successfully!"
          );
        }
      }
    );
  };

  updateRecord = async (data, id, customMessage) => {
    this.setState({
      dataLoadingStatus: true,
    });
    data["entityData"]["typeofPage"] = "orderDetails";
    data["entityData"]["recordId"] = this.props.match.params.id;
    update(AppConfigs["entityNames"]["leads"], id, data).then((result) => {
      if (result.success) {
        if (customMessage !== "") {
          // alert(message);
          message.success(customMessage);
          this.getCategoriesAndSubCategories(
            "carrierTag",
            "subCategoriesDataLoading"
          );
          this.getAuditTrailsDetails();
          this.setState({
            dataLoadingStatus: false,
            showModal: false,
            locationEdit: false,
            notesEdit: false,
            defeoNotesEdit: false,
            rateEdit: false,
            tagsEdit: false,
            deliveryNotesEdit: false,
            rateModal: false,
            loading: false,
          });
        }
        return result.data;
      } else {
        this.setState({
          loading: false,
        });
        this.getAuditTrailsDetails();
        console.log(result.errors);
      }
    });
    await this.getAuditTrailsDetails();
    this.setState({ productModal: false });
  };

  reAssignLead = async () => {
    let data = {
      entityData: {
        pushToCarrier: false,
        assignCarrier: false,
        orderStatus: AppConfigs["ORDER_PROCESSED"],
        carrierDetails: {},
        reassign: true,
      },
    };
    await this.updateRecord(
      data,
      this.props.match.params.id,
      "Load updated successfully!"
    );
  };

  openConfirmModal = async (productId) => {
    this.setState({
      dataLoadingStatus: true,
    });
    getDetails(AppConfigs["getProductDetails"], productId).then(
      async (productRes) => {
        if (productRes.success) {
          let productLocations = this.state.orgDetails["yardLocations"].filter(
            (loc) => productRes.data.productOrigin.indexOf(loc.id) > -1
          );
          this.setState({
            productLocations: productLocations,
            dataLoadingStatus: false,
            // confirmModal: true,
          });
        } else {
          this.setState({
            dataLoadingStatus: false,
          });
        }
      }
    );
    this.orderConfirm();
  };

  fileDownload = async (fileName) => {
    this.setState({
      uploadCompanyLogoLoading: true,
    });
    Storage.get(fileName, { download: true }).then((res) =>
      this.downloadBlob(res.Body, fileName)
    );
  };

  downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    this.setState({
      uploadCompanyLogoLoading: false,
      downloadDeliveryPicLoading: false,
      downloadDeliveryTicketLoading: false,
    });
    return a;
  }

  pushToCarriers = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["callForRate", "rateValue", "rateOption"],
      async (err, values) => {
        if (!err) {
          this.setState({
            loading: false,
          });
          let rateValue = null,
            rateAmt = null,
            rateOption = null,
            callForRate = false;
          if ("callForRate" in values) {
            if (
              (values["rateValue"] === "" ||
                !values["rateValue"] ||
                !values["rateOption"]) &&
              !values["callForRate"]
            ) {
              this.setState({
                rateErrorMsg:
                  "Please enter rate value and rate option or check the call for rate!",
              });
              message.error(
                "Please enter rate value and rate option or check the call for rate!"
              );
              return;
            }
            if (!values["callForRate"]) {
              rateAmt = values["rateValue"];
              rateOption = values["rateOption"];
              // rateValue = values["rateOption"] === "measurementType" ? parseFloat(values["rateValue"]) * parseInt(this.state.leadData["cartItems"][0]["quantity"]) : values["rateValue"];
              rateValue =
                values["rateOption"] === "measurementType"
                  ? parseFloat(values["rateValue"]) *
                    parseInt(this.state.leadData["cartItems"][0]["quantity"])
                  : values["rateValue"];
            }
            callForRate = values["callForRate"];
          } else {
            rateValue = this.state.leadData["rateValue"];
            rateAmt = this.state.leadData["rateAmt"];
            rateOption = this.state.leadData["rateOption"];
            callForRate = this.state.leadData["callForRate"];
          }

          let data = {
            entityData: {
              leadId: this.state.leadData["id"],
              rateValue: rateValue,
              rateAmt: rateAmt,
              rateOption: rateOption,
              callForRate: callForRate,
            },
          };
          await this.updateRecord(
            data,
            this.props.match.params.id,
            "Rate updated successfully!"
          );
          this.setState({
            loading: true,
          });
        }
      }
    );
  };

  markAsStatus = async (markAsId, id) => {
    // this.setState({
    //   loading: true,
    // });
    let data = {
      entityData: {
        [markAsId]: true,
        recordId: id,
        typeofPage: "orderDetails",
      },
    };
    if (markAsId === "markAsDeleted") {
      data["entityData"] = { ...data["entityData"], orderStatus: "DELETE" };
    }
    if (markAsId === "Customer Canceled") {
      delete data["entityData"]["Customer Canceled"];
      data["entityData"] = { ...data["entityData"], orderStatus: "R" };
    }
    if (markAsId === "markAsInvoiced") {
      data["entityData"] = { ...data["entityData"], orderStatus: "INV" };
    }
    if (markAsId === "markAsPaid") {
      data["entityData"] = { ...data["entityData"], orderStatus: "PAID" };
    }
    if (markAsId === "pushToCarrier") {
      this.setState({
        showPushToCarrierModal: true,
        // rateModal: true,
        // callForRateValue: leadData["callForRate"],
      });
    } else if (markAsId === "assignCarrier") {
      this.setState({
        showModal: true,
      });
      // } else if (markAsId === "Reassign") {
      //   if (window.confirm("Are you sure you want to reassign this load?"))
      //     this.reAssignLead();
    } else if (markAsId === "loadDelivered") {
      this.setState({
        showLoadDeliveredModal: true,
      });
      // } else if (markAsId === "ConfirmOrder") {
      //   this.openConfirmModal(this.state.leadData["cartItems"][0]["productId"]);
    } else {
      await this.updateRecord(data, id, "Record updated successfully!");
    }

    // if (markAsId === "ConfirmOrder") {
    //   this.openConfirmModal(this.state.leadData["cartItems"][0]["productId"]);
    // }
    // if (markAsId === "CancelOrder") {
    //   this.setState({
    //     showCancelPopUp: true,
    //   });
    // }
  };

  handlecancelOrder = () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    const { leadData, customerData } = this.state;
    this.setState({
      dataLoadingStatus: true,
    });
    let data = {
      entityData: {
        orderStatus: AppConfigs["CANCELLED"],
        cancelledTime: moment().valueOf(),
      },
    };
    let totalAmount = 0;
    leadData["cartItems"] &&
      leadData["cartItems"].map(
        (amount) =>
          (totalAmount = parseInt(totalAmount) + parseInt(amount.totalAmt))
      );
    totalAmount = parseInt(leadData["deliveryAmt"]) + parseInt(totalAmount);
    console.log(totalAmount, customerData["presentCreditAmount"]);
    let amount =
      parseInt(customerData["presentCreditAmount"]) + parseInt(totalAmount);
    let data1 = {
      entityData: {
        presentCreditAmount: amount,
      },
    };
    data1["entityData"]["typeofPage"] = "customerDetails";
    data1["entityData"]["recordId"] = orgDetails["id"];
    update("customerAndCarrierRegistrations", customerData["id"], data1).then(
      (result) => {
        if (result.success) {
          this.setState({
            customerData: {
              presentCreditAmount: result.data.data.presentCreditAmount,
            },
          });
        } else {
          console.log(result.error);
        }
      }
    );
    data["entityData"]["typeofPage"] = "orderDetails";
    data["entityData"]["recordId"] = this.props.match.params.id;
    update(
      AppConfigs["entityNames"]["leads"],
      this.props.match.params.id,
      data
    ).then((result) => {
      if (result.success) {
        message.success("Lead cancelled successfully");
        this.setState({
          leadData: result.data.data,
          dataLoadingStatus: false,
        });
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
  };

  deleteImage = (type) => {
    let { image1, image2, image3, image4 } = "";
    const { leadData } = this.state;

    if (type === "customer_sign") {
      this.setState({
        imageLoading1: true,
      });
      image1 = true;
    } else if (type === "driver_sign") {
      this.setState({
        imageLoading2: true,
      });
      image2 = true;
    } else if (type === "delivery_ticket") {
      this.setState({
        imageLoading3: true,
      });
      image3 = true;
    } else if (type === "delivery_pic") {
      this.setState({
        imageLoading4: true,
      });
      image4 = true;
    }

    let deliveryImagesList = {
      customer_sign: image1 ? "" : leadData.leadDeliveryImage.customer_sign,
      driver_sign: image2 ? "" : leadData.leadDeliveryImage.driver_sign,
      delivery_ticket_pic: image3
        ? ""
        : leadData.leadDeliveryImage.delivery_ticket_pic,
      delivery_pic: image4 ? "" : leadData.leadDeliveryImage.delivery_pic,
    };
    this.ImageUpdation(deliveryImagesList, type, "delete");
  };

  handleUpdateImage = async (info, type) => {
    let { image1, image2, image3, image4 } = "";
    if (type === "customer_sign") {
      this.setState({
        imageLoading1: true,
      });
    } else if (type === "driver_sign") {
      this.setState({
        imageLoading2: true,
      });
    } else if (type === "delivery_ticket") {
      this.setState({
        imageLoading3: true,
      });
    } else if (type === "delivery_pic") {
      this.setState({
        imageLoading4: true,
      });
    }
    switch (info.file.status) {
      case "done":
        this.setState({
          fileList: info.fileList,
        });
        if (info.fileList.length > 0 && info.file.status !== "removed") {
          try {
            if (info.file.size > 0) {
              let file = info.file.originFileObj;
              let leadData = this.state.leadData;
              let fileName = leadData["subOrderId"] + "_" + type + file["name"];
              await Storage.put(fileName, file, {
                // Storage.put(info.file.uid, info.file.originFileObj, {
                contentType: info.file.type,
              }).then((result) => {
                if (type === "customer_sign") {
                  image1 = result.key;
                } else if (type === "driver_sign") {
                  image2 = result.key;
                } else if (type === "delivery_ticket") {
                  image3 = result.key;
                } else if (type === "delivery_pic") {
                  image4 = result.key;
                }
                this.savePic(image1, image2, image3, image4, type);
              });
            } else {
              this.setState({
                imageLoading1: false,
                imageLoading2: false,
                imageLoading3: false,
                imageLoading4: false,
              });
            }
          } catch (err) {
            console.log(err, "errr");
          }
        }
        break;
      default:
        this.setState({
          imageLoading1: false,
          imageLoading2: false,
          imageLoading3: false,
          imageLoading4: false,
        });
    }
  };

  savePic = async (data1, data2, data3, data4, type) => {
    const { leadData } = this.state;
    let deliveryImagesList = {
      customer_sign:
        data1 !== undefined ? data1 : leadData.leadDeliveryImage.customer_sign,
      driver_sign:
        data2 !== undefined ? data2 : leadData.leadDeliveryImage.driver_sign,
      delivery_ticket_pic:
        data3 !== undefined
          ? data3
          : leadData.leadDeliveryImage.delivery_ticket_pic,
      delivery_pic:
        data4 !== undefined ? data4 : leadData.leadDeliveryImage.delivery_pic,
    };
    this.ImageUpdation(deliveryImagesList, type, "update");
  };

  ImageUpdation = (deliveryImagesList, type, messageType) => {
    const data = {
      entityData: {
        leadDeliveryImage: deliveryImagesList,
      },
    };

    if (data.entityData.leadDeliveryImage !== "") {
      update(
        AppConfigs["entityNames"]["leads"],
        this.props.match.params.id,
        data
      )
        .then((result) => {
          if (result.success) {
            if (type === "customer_sign") {
              this.setState({
                imageLoading1: false,
              });
            } else if (type === "driver_sign") {
              this.setState({
                imageLoading2: false,
              });
            } else if (type === "delivery_ticket") {
              this.setState({
                imageLoading3: false,
              });
            } else if (type === "delivery_pic") {
              this.setState({
                imageLoading4: false,
              });
            }
            message.success(
              messageType === "update"
                ? type + " updated successfully"
                : type + " deleted successfully"
            );
            this.setState({
              dataLoadingStatus: true,
            });
            this.getLeadData();
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            imageLoading1: false,
            imageLoading2: false,
            imageLoading3: false,
            imageLoading4: false,
          });
        });
    }
  };

  updateWeightEdit = (type) => {
    const { leadData } = this.state;
    this.props.form.validateFieldsAndScroll(
      ["tNumber", "grossWeight", "tareWeight"],
      async (err, values) => {
        if (!err) {
          let grossWeight = values["grossWeight"]
            ? values["grossWeight"]
            : leadData["weight"] && leadData["weight"]["grossWeight"];
          let tareWeight = values["tareWeight"]
            ? values["tareWeight"]
            : leadData["weight"] && leadData["weight"]["tareWeight"];
          let data = {
            entityData: {
              weight: {
                grossWeight: grossWeight,
                tareWeight: tareWeight,
                netWeight: parseFloat(grossWeight - tareWeight) / 2000,
              },
              ticketNumber: values["tNumber"]
                ? values["tNumber"]
                : leadData["ticketNumber"],
            },
          };
          let netData = {
            entityData: {
              netWeight: parseFloat(grossWeight - tareWeight) / 2000,
            },
          };

          this.updateRecord(
            data,
            this.props.match.params.id,
            "Updated Successfully"
          );

          if (leadData["measurementType"] !== "Pallet" && type !== "ticket") {
            this.updateNetWeight(netData, this.props.match.params.id);
          }
        }
      }
    );
  };

  updateNetWeight = (data, id) => {
    this.setState({
      dataLoadingStatus: true,
    });
    update(AppConfigs["entityNames"]["netWeight"], id, data).then((result) => {
      if (result.success) {
        console.log(result.data);
        this.setState({
          dataLoadingStatus: false,
        });
      } else {
        this.setState({
          dataLoadingStatus: false,
          loading: false,
        });
        console.log(result.errors);
      }
    });
  };

  handleWeightChanges = (e) => {
    this.setState({
      ticketNumber: e.target.value,
    });
  };

  updateLoactionEdit = () => {
    const { leadData, updatedLoaction } = this.state;
    let orgLocations = this.state.orgDetails["yardLocations"];
    let productOriginDetails = orgLocations.filter(
      (l) => l.id === updatedLoaction
    );
    let data = {
      entityData: {
        productOriginDetails:
          productOriginDetails.length > 0
            ? productOriginDetails[0]
            : leadData["productOriginDetails"],
      },
    };
    data["entityData"]["typeofPage"] = "orderDetails";
    data["entityData"]["recordId"] = this.props.match.params.id;
    this.setState({
      pickupLocationEdit: false,
      dataLoadingStatus: true,
    });
    update(
      AppConfigs["updateOrderPickupLocation"],
      this.props.match.params.id,
      data
    ).then((result) => {
      if (result.success) {
        console.log(result);
        message.success("Location updated successfully!");
        window.location.reload();
        this.setState({
          dataLoadingStatus: false,
        });
        return result.data;
      } else {
        this.setState({
          loading: false,
          pickupLocationEdit: false,
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
  };

  getStartDisabledHours = () => {
    const minHour = -1;
    const maxHour = this.state.endValue ? this.state.endValue.hours() : 24;
    return Array.from({ length: 24 }, (v, k) => k).filter(
      (hour) => hour < minHour || hour > maxHour
    );
  };

  getStartDisabledMinutes = (startSelectedHour) => {
    const minMinutes = -1;
    const maxMinutes =
      this.state.endValue && startSelectedHour >= this.state.endValue.hours()
        ? this.state.endValue.minutes()
        : 60;

    return Array.from({ length: 60 }, (v, k) => k).filter(
      (minutes) => minutes <= minMinutes || minutes >= maxMinutes
    );
  };

  getEndDisabledHours = () => {
    const minHour = this.state.startTime ? this.state.startTime.hours() : -1;
    const maxHour = 24;
    return Array.from({ length: 24 }, (v, k) => k).filter(
      (hour) => hour < minHour || hour > maxHour
    );
  };

  getEndDisabledMinutes = (endSelectedHour) => {
    const minMinutes =
      this.state.startTime && endSelectedHour <= this.state.startTime.hours()
        ? this.state.startTime.minutes()
        : -1;
    const maxMinutes = 60;
    return Array.from({ length: 60 }, (v, k) => k).filter(
      (minutes) => minutes <= minMinutes || minutes >= maxMinutes
    );
  };

  handleStartTime = (value, type) => {
    if (this.state.EndTime !== "") {
      this.setState({
        EndTime: "",
      });
    }
    this.setEndValue(value, type);
    this.setState({
      startTime: value,
    });
  };

  handleEndTime = (value, type) => {
    if (this.state.startTime === "") {
      message.error("Please input requested delivery start time First");
      return;
    } else {
      this.setEndValue(value, type);
      this.setState({
        EndTime: value,
      });
    }
  };

  handleChangeWeight = (e, type) => {
    if (type === "gWeight") {
      this.setState({
        gWeight: e.target.value,
      });
    } else {
      this.setState({
        tWeight: e.target.value,
      });
    }
  };

  markAsDelivered = () => {
    this.setState({
      showDeliveryModal: true,
    });
  };

  haandleDeleteImages = (imageType) => {
    if (imageType === "_delivery_ticket_pic_") {
      this.setState({
        imageUrl3: "",
        uploadPicLoading3: false,
      });
    } else {
      this.setState({
        imageUrl4: "",
        uploadPicLoading4: false,
      });
    }
  };

  handleUploadPic = async (fileData, imageType) => {
    if (imageType === "_delivery_ticket_pic_") {
      this.setState({
        imageUrl3: "",
      });
    } else {
      this.setState({
        imageUrl4: "",
      });
    }
    if (fileData["file"]["originFileObj"]) {
      if (imageType === "_delivery_ticket_pic_") {
        this.setState({
          uploadPicLoading3: true,
        });
      } else {
        this.setState({
          uploadPicLoading4: true,
        });
      }
      let file = fileData["file"]["originFileObj"];
      let fileName =
        this.state.leadData &&
        this.state.leadData["subOrderId"] + imageType + file["name"];
      await Storage.put(fileName, file, {
        contentType: file.type,
      }).then(async (result) => {
        if (imageType === "_delivery_ticket_pic_") {
          this.setState({
            imageUrl3: result.key,
            uploadPicLoading3: false,
          });
        } else {
          this.setState({
            imageUrl4: result.key,
            uploadPicLoading4: false,
          });
        }
      });
    }
  };

  onFinish = (e) => {
    this.props.form.validateFields(
      ["deliveryDate", "deliveryTime", "ticketNumber", "gWeight", "tWeight"],
      (err, values) => {
        if (!err) {
          this.setState({
            loading: true,
          });
          const { imageUrl3, imageUrl4 } = this.state;

          let deliveryImagesList = {
            delivery_ticket_pic: imageUrl3 ? imageUrl3 : "",
            delivery_pic: imageUrl4 ? imageUrl4 : "",
          };

          let data = {
            entityData: {
              deliveryDateAndTime:
                moment(values["deliveryDate"]).format("MM/DD/YYYY") +
                " " +
                moment(values["deliveryTime"]).format("hh:mm A"),
              deliveryReqDate: moment(values["deliveryDate"]).format(
                "MM/DD/YYYY"
              ),
              deliveryReqTime: moment(values["deliveryTime"]).format("hh:mm A"),
              leadDeliveryImage: deliveryImagesList,
              orderStatus: AppConfigs["DELIVERED"],
              ticketNumber: values["ticketNumber"],
              weight: {
                grossWeight: parseInt(values["gWeight"]),
                tareWeight: parseInt(values["tWeight"]),
                netWeight:
                  parseFloat(values["gWeight"] - values["tWeight"]) / 2000,
              },
            },
          };
          data["entityData"]["typeofPage"] = "orderDetails";
          data["entityData"]["recordId"] = this.props.match.params.id;
          update(
            AppConfigs["entityNames"]["leads"],
            this.props.match.params.id,
            data
          ).then((result) => {
            if (result.success) {
              message.success("Load updated successfully!");
              this.setState({
                showDeliveryModal: false,
              });
              window.location.reload();
            } else {
              this.setState({
                loading: false,
              });
              console.log(result.errors);
            }
          });

          let netData = {
            entityData: {
              netWeight:
                parseFloat(values["gWeight"] - values["tWeight"]) / 2000,
            },
          };
          this.updateNetWeight(netData, this.props.match.params.id);
        }
      }
    );
  };

  handleSubmit = () => {
    this.setState({
      dataLoadingStatus: true,
    });
    let data = {
      entityData: {
        deliveryDateAndTime:
          moment(new Date()).format("MM/DD/YYYY") +
          " " +
          moment(new Date()).format("hh:mm A"),
        deliveryReqDate: moment(new Date()).format("MM/DD/YYYY"),
        deliveryReqTime: moment(new Date()).format("hh:mm A"),
        orderStatus: AppConfigs["DELIVERED"],
      },
    };
    data["entityData"]["typeofPage"] = "orderDetails";
    data["entityData"]["recordId"] = this.props.match.params.id;
    update(
      AppConfigs["entityNames"]["leads"],
      this.props.match.params.id,
      data
    ).then((result) => {
      if (result.success) {
        message.success("Load updated successfully!");
        this.getLeadData();
        // window.location.reload()
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
  };

  handleEventRender = (event, record) => {
    return (
      <>
        {event.changedFieldName === "notes" ? (
          <div style={{ display: "flex" }}>
            {" "}
            PickUp Notes Changed &nbsp;{" "}
            <p>
              {"oldFields" in event === true && (
                <>
                  {" "}
                  from <b> {isNaN(event.oldFields) ? "" : event.oldFields} </b>
                </>
              )}{" "}
              {"modifiedField" in event === true && (
                <>
                  {" "}
                  to <b> {event.modifiedField} </b>
                </>
              )}
            </p>
          </div>
        ) : event.changedFieldName === "poNumber" ? (
          <div style={{ display: "flex" }}>
            PO # Changed from &nbsp;{" "}
            <p>
              <b>{event.oldFields}</b> to<b> {event.modifiedField}</b>
            </p>
          </div>
        ) : event.changedFieldName === "defeoNotes" ? (
          <div style={{ display: "flex" }}>
            Order notes Changed &nbsp;{" "}
            <p>
              {"oldFields" in event === true && (
                <>
                  {" "}
                  from <b> {event.oldFields} </b>
                </>
              )}{" "}
              {"modifiedField" in event === true && (
                <>
                  {" "}
                  to <b> {event.modifiedField} </b>
                </>
              )}
            </p>
          </div>
        ) : event.changedFieldName === "deliveryReqDate" ||
          event.changedFieldName === "deliveryReqTime" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Requested Delivery{" "}
            {event.changedFieldName === "deliveryReqDate" ? "Date" : "Time"}{" "}
            changed from{" "}
            <b>
              {event.oldFields !== "" && (
                <>
                  {event.oldFields}
                  {" to "}
                </>
              )}
            </b>
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "locationName" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            {/* Delivery Location Changed from <b>{event.oldFields}</b> */}
            {"locationType" in event === true &&
            event.locationType === "pickupLocation"
              ? "Pickup Location"
              : "Delivery Location"}{" "}
            Changed from <b>{event.oldFields}</b>
            {event.oldFields ? <span>&nbsp;to&nbsp;</span> : ""}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "productName" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Product Name Changed from <b>{event.oldFields}</b>{" "}
            {event.oldFields ? <span>&nbsp;to&nbsp;</span> : ""}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "amount" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Product{" "}
            {"productName" in record === true && <b> {record.productName} </b>}{" "}
            Price Changed from <b>{priceFormate(event.oldFields)}</b>{" "}
            {event.oldFields ? <span>&nbsp;to&nbsp;</span> : ""}
            <b> {priceFormate(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "size" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Product Size Changed to <b>{event.oldFields}</b>{" "}
            {event.oldFields ? <span>&nbsp;to&nbsp;</span> : ""}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "tags" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            tags Changed to <b>{event.oldFields}</b>{" "}
            {event.oldFields ? <span>&nbsp;to&nbsp;</span> : ""}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "deliveryTruck" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            DeliveryTruck Changed from <b>{event.oldFields}</b>
            {event.oldFields ? <span>&nbsp;to&nbsp;</span> : ""}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "totalAmt" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Total Amount Changed from <b>{priceFormate(event.oldFields)}</b>{" "}
            {event.oldFields ? <span>&nbsp;to&nbsp;</span> : ""}
            <b> {priceFormate(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "distanceMiles" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Distance Changed from{" "}
            <b>
              {isNaN(event.oldFields) || event.oldFields === null
                ? 0
                : parseFloat(event.oldFields).toFixed(2)}
            </b>{" "}
            {isNaN(event.oldFields) || event.oldFields === null ? (
              <span>&nbsp;to&nbsp;</span>
            ) : (
              ""
            )}
            <b>
              {isNaN(event.oldFields)
                ? 0
                : parseFloat(event.modifiedField).toFixed(2)}
            </b>
          </p>
        ) : event.changedFieldName === "orderStatus" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Order Status Changed from{" "}
            <b>
              {
                AppConfigs["DISPLAY_LEAD_STATUS"][
                  "customer"
                  // event.modifiedField === "PS" || event.modifiedField === "PU"
                  //   ? "customer"
                  //   : "admin"
                ][event.oldFields]
              }
            </b>{" "}
            {event.oldFields ? <span>&nbsp;to&nbsp;</span> : ""}
            <b>
              {
                AppConfigs["DISPLAY_LEAD_STATUS"][
                  "customer"
                  // event.modifiedField === "PS" || event.modifiedField === "PU"
                  //   ? "customer"
                  //   : "admin"
                ][event.modifiedField]
              }
            </b>
          </p>
        ) : event.changedFieldName === "markAsInvoiced" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Order Status Changed from{" "}
            <b>{event.modifiedField && "Mark As Invoiced"}</b>
          </p>
        ) : event.changedFieldName === "markAsPaid" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Order Status Changed from{" "}
            <b>{event.modifiedField && "Mark As Paid"}</b>
          </p>
        ) : event.changedFieldName === "rateValue" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Order Rate Changed from <b>{`$ ${event.modifiedField}`}</b>
          </p>
        ) : "allChangedFields" in event === true &&
          event.allChangedFields[0] === "grossWeight" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Gross Weight Changed from{" "}
            <b> {priceFormate(event.oldFields, false)} </b> to{" "}
            <b> {priceFormate(event.modifiedField, false)}</b>
          </p>
        ) : "allChangedFields" in event === true &&
          event.allChangedFields[0] === "tareWeight" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Tare Weight Changed from{" "}
            <b> {priceFormate(event.oldFields, false)} </b> to{" "}
            <b> {priceFormate(event.modifiedField, false)}</b>
          </p>
        ) : event.changedFieldName === "ticketNumber" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Truck Number Changed from <b> {event.oldFields} </b> to{" "}
            <b> {event.modifiedField}</b>
          </p>
        ) : (
          ""
        )}
      </>
    );
  };

  hideModal = () => {
    this.setState({ showModal: false });
  };

  hidePushToCarrierModal = () => {
    this.setState({ showPushToCarrierModal: false });
  };

  hideLoadDeliveredModal = () => {
    this.setState({ showLoadDeliveredModal: false });
  };

  sendBOL = async (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(["emails"], async (err, values) => {
      if (!err) {
        let listOfEmails = values.emails.toString();
        this.setState({
          dataLoadingStatus: true,
          sendMailloading: true,
        });

        getDetails(
          AppConfigs["sendBol"],
          `${this.props.match.params.id}?userEmails=${encodeURIComponent(
            listOfEmails
          )}`
        ).then(async (result) => {
          if (result.success) {
            message.success("BOL sent successfully!");
            this.setState({
              dataLoadingStatus: false,
              sendMailloading: false,
              bolModal: false,
            });
          } else {
            console.log(result.errors);
            this.setState({
              dataLoadingStatus: false,
              sendMailloading: false,
              bolModal: false,
            });
          }
        });
      }
    });
  };

  render() {
    const {
      auditDetails,
      uploadPicLoading3,
      uploadPicLoading4,
      imageUrl3,
      imageUrl4,
      leadData,
      dataLoadingStatus,
      customerData,
      confirmModal,
      selectedProduct,
      productModal,
      callForRateValue,
      locations,
      tagsEdit,
      deliveryEdit,
      notesEdit,
      defeoNotesEdit,
      productsData,
      locationEdit,
      productUpdateLoading,
      rateModal,
      loading,
      rateErrorMsg,
      masterData,
      productLocations,
      pickupLocationEdit,
      ticketEdit,
      gWeightEdit,
      tWeightEdit,
      showDeliveryModal,
      rateEdit,
      deliveryNotesEdit,
      // auditDetailsList,
    } = this.state;

    const auditColumns = [
      {
        title: "DATE AND TIME",
        dataIndex: "createdAt",
        key: "createdAt",
        align: "left",
        width: "25%",
        render: (createdAt) => (
          <p style={{ color: "black", fontSize: "14px" }}>
            {moment(createdAt).format("MM/DD/YYYY hh:mm a")}
          </p>
        ),
      },
      {
        title: "ACTION DONE BY",
        dataIndex: "firstName",
        className: "audit-column-headings",
        key: "createdAt",
        align: "left",
        width: "25%",
        render: (firstName, record) => (
          <p style={{ color: "black", fontSize: "14px" }}>
            {record.firstName + " " + record.lastName}
          </p>
        ),
      },
      {
        title: "EVENT",
        dataIndex: "auditTrailDetails",
        key: "auditTrailDetails",
        render: (auditTrailDetails, record) => (
          <>
            {record.auditTrailDetails.map((change, index) =>
              this.handleEventRender(change, record)
            )}
          </>
        ),
      },
    ];
    const rolePermisions = this.props?.context?.state?.permissions;

    const { getFieldDecorator, getFieldValue } = this.props.form;
    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px",
    };
    let totalAmount = 0;
    leadData["cartItems"] &&
      leadData["cartItems"].map(
        (amount) =>
          (totalAmount = parseFloat(totalAmount) + parseFloat(amount.totalAmt))
      );

    totalAmount = parseFloat(leadData["deliveryAmt"]) + parseFloat(totalAmount);
    const columns = [
      {
        title: <div style={{ color: "gray" }}>Product Name</div>,
        dataIndex: "productName",
        key: "productName",
        render: (productName, record) => (
          <div style={{ color: "black" }}>
            {record.size + " " + productName}
          </div>
        ),
      },
      {
        title: (
          <div style={{ color: "gray" }}>
            {leadData["measurementType"] === "Pallet" ? "Ton" : "Size"}
          </div>
        ),
        dataIndex: "size",
        key: "size",
        render: (size, record) => (
          <div style={{ color: "black" }}>
            {leadData["measurementType"] === "Pallet"
              ? record["ton"]?.split("Ton")
              : size}
          </div>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Measurement</div>,
        dataIndex: "measurementType",
        key: "measurementType",
        render: (measurementType, record) => (
          <span>
            <div style={{ color: "black" }}>
              {measurementType &&
                measurementType[0].toUpperCase() +
                  measurementType.substring(1).toLowerCase()}
            </div>
          </span>
        ),
      },
      {
        title: (
          <div style={{ color: "gray" }}>
            {leadData["measurementType"] === "Pallet" ? "Quantity" : "Ton"}
          </div>
        ),
        dataIndex: "quantity",
        key: "quantity",
        render: (quantity, record) => (
          <span>
            <div style={{ color: "black" }}>
              {leadData["orderStatus"] !== "D"
                ? leadData["measurementType"] === "Pallet"
                  ? quantity
                  : record.deliveryTruck[0] === "OpenTop"
                  ? 110
                  : record.deliveryTruck[0] === "GondolaRailcar"
                  ? 99
                  : 24
                : leadData["measurementType"] === "Pallet"
                ? quantity
                : leadData["weight"]?.["netWeight"]}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Type of Truck</div>,
        dataIndex: "deliveryTruck",
        key: "deliveryTruck",
        render: (deliveryTruck) =>
          Array.isArray(deliveryTruck) ? (
            deliveryTruck?.map((item, index) =>
              index === deliveryTruck.length - 1 ? (
                <span key={index + 1}>
                  <div style={{ color: "black" }}>{item}</div>
                </span>
              ) : (
                <span key={index + 1}>
                  <div style={{ color: "black" }}>{item},</div>
                </span>
              )
            )
          ) : (
            <div style={{ color: "black" }}>{deliveryTruck}</div>
          ),
      },

      {
        title: <div style={{ color: "gray" }}>Price Per Tone</div>,
        dataIndex: "amount",
        key: "amount",
        render: (price, record) => (
          <span>
            <div style={{ color: "black" }}>
              <NumberFormat
                value={parseFloat(price).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
              {/* {price ? "$" + parseFloat(price).toFixed(2) : "0"} */}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Total</div>,
        dataIndex: "totalAmt",
        key: "totalAmt",
        render: (total) => (
          <span>
            <div style={{ color: "black" }}>
              <NumberFormat
                value={parseFloat(total).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
              {/* {total ? "$" + parseFloat(total).toFixed(2) : "0"} */}
            </div>
          </span>
        ),
      },
      {
        title: "",
        key: "id",
        render: (text, record) => (
          <div>
            {leadData["orderStatus"] !== "D" &&
              rolePermisions &&
              rolePermisions[0]?.permissions?.includes("editOrder") && (
                <Button
                  type="primary"
                  onClick={() => this.productModal(record.id)}
                >
                  Edit
                </Button>
              )}
          </div>
        ),
      },
    ];
    const subUserColumns = [
      {
        title: <div style={{ color: "gray" }}>Full Name</div>,
        dataIndex: "firstName",
        key: "firstName",
        render: (firstName, record) => (
          <span style={{ color: "black" }}>
            {firstName + " " + record.lastName}
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Email</div>,
        dataIndex: "email",
        key: "email",
        render: (email) => (
          <span>
            <div style={{ color: "black" }}>{email}</div>
          </span>
        ),
      },
    ];

    if (
      this.state.userDetails.userProfile !== "A" &&
      this.state.userDetails.userProfile !== "M"
    ) {
      return <ErrorPage />;
    }

    return (
      <div style={{ position: "absolute", top: "135px", width: "100%" }}>
        <Spin spinning={dataLoadingStatus}>
          <div>
            <Row style={{ margin: "20px" }}>
              <Menu
                mode="horizontal"
                style={{ backgroundColor: "rgb(14, 77, 144)" }}
              >
                <Menu.Item key="1">
                  <Link to="/app/loads">
                    <h3 style={{ color: "#fff" }}>
                      <ArrowLeftOutlined style={{ fontSize: "1em" }} />
                      Back to list
                    </h3>
                  </Link>
                </Menu.Item>
                <Menu.Item key="2" style={{ cursor: "default" }}>
                  <h2 style={{ color: "#fff" }}>
                    {"ON: #" +
                      (this.state.leadData["orderId"]
                        ? this.state.leadData["orderId"]
                        : "")}
                  </h2>
                </Menu.Item>
                <Menu.Item key="3" style={{ cursor: "default" }}>
                  <h3 style={{ color: "#fff" }}>
                    STATUS :
                    {
                      <span className="status_tag">
                        &nbsp;
                        <Tag
                          color={
                            AppConfigs["STATUS_COLORS"][
                              this.state.leadData["orderStatus"]
                            ]
                          }
                          style={{
                            color: "black",
                            height: "27px",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {
                            // this.state.leadData["markAsDeleted"]
                            //   ? AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][
                            //       "DELETE"
                            //     ]
                            //   : this.state.leadData["markAsNew"]
                            //   ? AppConfigs["DISPLAY_LEAD_STATUS"]["admin"]["N"]
                            //   : this.state.leadData["markAsPaid"]
                            //   ? AppConfigs["DISPLAY_LEAD_STATUS"]["admin"]["PAID"]
                            //   : this.state.leadData["markAsInvoiced"]
                            //   ? AppConfigs["DISPLAY_LEAD_STATUS"]["admin"]["INV"]
                            //   :

                            leadData.deliveryTruck &&
                            (leadData.deliveryTruck.includes(
                              "Customer Pickup"
                            ) ||
                              leadData.deliveryTruck === "CustomerPickup") &&
                            this.state.leadData["orderStatus"] === "OP"
                              ? "Pending Customer Pickup"
                              : leadData.deliveryTruck &&
                                (leadData.deliveryTruck.includes(
                                  "Customer Pickup"
                                ) ||
                                  leadData.deliveryTruck ===
                                    "CustomerPickup") &&
                                this.state.leadData["orderStatus"] === "D"
                              ? "Customer Picked Up"
                              : this.state.leadData["orderStatus"] === "PC" &&
                                this.state.leadData["tags"].length > 0
                              ? "Push to  Carrier"
                              : this.state.leadData["carrierRequests"]
                              ? "Assigned"
                              : AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][
                                  this.state.leadData["orderStatus"]
                                ]
                          }
                        </Tag>
                      </span>
                    }
                  </h3>
                </Menu.Item>
                <Menu.Item key="4" style={{ cursor: "default" }}>
                  <h3 style={{ color: "#fff" }}>DISPATCHER :</h3>
                </Menu.Item>
                <Menu.Item key="5" style={{ float: "right" }}>
                  <h3 style={{ color: "#fff" }}>
                    <GeneratePdf
                      leadData={this.state.leadData}
                      callFrom="orders"
                      pathName="loaddetails"
                      startLoading={() =>
                        this.setState({ dataLoadingStatus: true })
                      }
                      stopLoading={() =>
                        this.setState({ dataLoadingStatus: false })
                      }
                    />
                  </h3>
                </Menu.Item>
                {leadData["orderStatus"] &&
                  rolePermisions &&
                  rolePermisions[0]?.permissions?.includes(
                    "updateOrderStatus"
                  ) &&
                  (leadData["orderStatus"] === "P" ||
                    leadData["orderStatus"] === "N") && (
                    <Menu.Item key="9" style={{ float: "right" }}>
                      <Popconfirm
                        // className="pop-Confirm"
                        placement="bottomLeft"
                        title={"Are you sure to cancel the order"}
                        onConfirm={this.handlecancelOrder}
                        okButtonProps={{
                          loading: dataLoadingStatus,
                        }}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          type="danger"
                          style={{
                            margin: "15px",
                            // background: "green",
                            // borderColor: "green",
                            color: "rgb(255, 255, 255)",
                          }}
                          icon="cross"
                        >
                          Cancel
                        </Button>
                      </Popconfirm>
                    </Menu.Item>
                  )}
                {leadData["orderStatus"] &&
                  rolePermisions &&
                  rolePermisions[0]?.permissions?.includes(
                    "updateOrderStatus"
                  ) &&
                  (leadData["orderStatus"] === "P" ||
                    leadData["orderStatus"] === "N") && (
                    <Menu.Item key="8" style={{ float: "right" }}>
                      <h3 style={{ color: "#fff" }}>
                        <Button
                          type="success"
                          style={{
                            margin: "15px",
                            background: "green",
                            borderColor: "green",
                            color: "rgb(255, 255, 255)",
                          }}
                          icon="check"
                          onClick={() => {
                            this.openConfirmModal(
                              leadData["cartItems"][0]["productId"]
                            );
                          }}
                        >
                          Approve
                        </Button>
                      </h3>
                    </Menu.Item>
                  )}
                {this.state.leadData["orderStatus"] &&
                  leadData["orderStatus"] !== "P" &&
                  leadData["orderStatus"] !== "N" && (
                    <Menu.Item key="6" style={{ float: "right" }}>
                      <>
                        <h2
                          style={{
                            color: "#fff",
                            float: "left",
                            marginRight: "20px",
                          }}
                        >
                          {"Mark as"}
                        </h2>
                        <Select
                          className="cartquantitydropdown"
                          notFoundContent={"Not found?!"}
                          defaultValue={"Select Status"}
                          onChange={(value) => {
                            this.markAsStatus(value, this.state.leadData["id"]);
                          }}
                          style={{ width: "170px", fontSize: "16px" }}
                        >
                          {/* <Option value="ConfirmOrder">Confirm Order</Option> */}
                          {!(
                            leadData.deliveryTruck &&
                            (leadData.deliveryTruck.includes(
                              "Customer Pickup"
                            ) ||
                              leadData.deliveryTruck === "CustomerPickup")
                          ) &&
                            leadData.measurementType !== "Pallet" && (
                              <Option value="pushToCarrier">
                                Push To Carrier
                              </Option>
                            )}
                          {!(
                            leadData.deliveryTruck &&
                            (leadData.deliveryTruck.includes(
                              "Customer Pickup"
                            ) ||
                              leadData.deliveryTruck === "CustomerPickup")
                          ) &&
                            leadData.measurementType !== "Pallet" && (
                              <Option value="assignCarrier">Assign</Option>
                            )}

                          {/* <Option value="Reassign">Reassign</Option> */}
                          <Option value="loadDelivered">Delivered</Option>
                          <Option value="markAsInvoiced">Invoiced</Option>
                          <Option value="markAsPaid">Paid</Option>
                          <Option value="Customer Canceled">
                            Customer Canceled
                          </Option>
                          <Option value="markAsDeleted">Delete</Option>
                          {/* <Option value="markAsNew">Mark As New</Option> */}
                        </Select>
                      </>
                    </Menu.Item>
                  )}
                {this.state.leadData["orderStatus"] &&
                  leadData["orderStatus"] !== "P" &&
                  leadData["orderStatus"] !== "N" &&
                  leadData.deliveryTruck &&
                  (leadData.deliveryTruck.includes("Customer Pickup") ||
                    leadData.deliveryTruck === "CustomerPickup") && (
                    <Menu.Item key="5" style={{ float: "right" }}>
                      <h3 style={{ color: "#fff" }}>
                        <Button
                          type="success"
                          style={{
                            // margin: "15px",
                            background: "green",
                            borderColor: "green",
                            color: "rgb(255, 255, 255)",
                          }}
                          // icon="check"
                          onClick={() => {
                            this.setState({ bolModal: true });
                          }}
                        >
                          Send BOL
                        </Button>
                      </h3>
                    </Menu.Item>
                  )}
                {this.state.leadData["orderStatus"] &&
                  leadData["orderStatus"] !== "P" &&
                  leadData["orderStatus"] !== "N" && (
                    <Menu.Item key="5" style={{ float: "right" }}>
                      <h3 style={{ color: "#fff" }}>
                        <Button
                          type="success"
                          style={{
                            // margin: "15px",
                            background: "green",
                            borderColor: "green",
                            color: "rgb(255, 255, 255)",
                          }}
                          // icon="check"
                          onClick={() => {
                            this.props.history.push({
                              pathname: "/app/loads/addLoad",
                              state: {
                                leadData: this.state.leadData,
                                customerData: this.state.customerData,
                              },
                            });
                          }}
                        >
                          Re-Order
                        </Button>
                      </h3>
                    </Menu.Item>
                  )}
                {this.state.showModal && (
                  <AssignToCarrier
                    leadData={this.state.leadData}
                    callFrom="details"
                    show={this.state.showModal}
                    hideModal={this.hideModal}
                    updateRecord={this.updateRecord}
                  />
                )}
                {this.state.showPushToCarrierModal && (
                  <PushToCarrier
                    leadData={this.state.leadData}
                    callFrom="details"
                    show={this.state.showPushToCarrierModal}
                    hideModal={this.hidePushToCarrierModal}
                  />
                )}
                {this.state.showLoadDeliveredModal && (
                  <LoadDelivered
                    leadData={this.state.leadData}
                    callFrom="adminDetails"
                    show={this.state.showLoadDeliveredModal}
                    hideModal={this.hideLoadDeliveredModal}
                  />
                )}
              </Menu>
            </Row>

            <Row gutter={20} style={{ margin: "40px 20px" }}>
              <Col lg={7} md={7} sm={24} xs={24}>
                <div className="site-card-border-less-wrapper">
                  <Card
                    title="Customer Details"
                    style={{ borderRadius: "10px", height: "auto" }}
                  >
                    <Row>
                      <Col
                        lg={10}
                        md={10}
                        sm={24}
                        xs={24}
                        style={{ textAlign: "center" }}
                      >
                        {customerData["companyLogo"] ? (
                          <img
                            src={customerData["companyLogo"]}
                            style={{ marginRight: "10px", width: "85px" }}
                            alt="logo"
                          />
                        ) : (
                          <img
                            src={companylogo}
                            style={{ marginRight: "10px", width: "85px" }}
                            alt="logo"
                          />
                        )}
                      </Col>
                      <Col
                        lg={14}
                        md={14}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "auto", marginBottom: "auto" }}
                      >
                        <h5 className="companynamelabel">COMPANY NAME</h5>
                        <h2 className="companyname">
                          {customerData["companyName"] &&
                            customerData["companyName"]}
                        </h2>
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <h5 className="contactinfo">CONTACT INFO</h5>
                      <div>
                        <img src={Iconuser} className="icons" alt="User icon" />
                        <span className="contactdetails">
                          {leadData["customerName"] && leadData["customerName"]}
                        </span>
                      </div>
                      <div>
                        <img src={Iconmail} className="icons" alt="Email" />
                        <span className="contactdetails">
                          {customerData["email"] && customerData["email"]}
                        </span>
                      </div>
                      <div>
                        <img src={Iconphone} className="icons" alt="Phone" />
                        <span className="contactdetails">
                          {customerData["phone"] &&
                            formatPhoneNumber(customerData["phone"])}
                        </span>
                      </div>
                      <div style={{ paddingBottom: "20px" }}>
                        <img
                          src={Iconlocation}
                          className="icons"
                          alt="Location"
                        />
                        <span className="contactdetails">
                          {customerData["address"] && customerData["address"]}
                        </span>
                      </div>
                    </Row>
                    <Divider />
                    <Row>
                      <h5 className="contactinfo">SubUser</h5>
                      <ResizableAntdTable
                        columns={subUserColumns}
                        dataSource={this.state.subUserList}
                        loading={this.state.dataLoading}
                        rowKey={(record) => record.id}
                        style={{ overflowX: "auto" }}
                      />
                    </Row>
                  </Card>
                </div>
              </Col>
              <Col lg={10} md={10} sm={24} xs={24}>
                <div className="site-card-border-less-wrapper">
                  <Card
                    title="Load History"
                    style={{ borderRadius: "10px", height: "auto" }}
                  >
                    <Row>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        <p>Date & Time Ordered</p>
                      </Col>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        <h3>
                          {leadData["createdAt"] &&
                            moment(leadData["createdAt"]).format("MM/DD/YYYY") +
                              "  " +
                              moment(leadData["createdAt"]).format("hh:mm A")}
                        </h3>
                      </Col>
                    </Row>
                    <Divider />
                    {deliveryEdit === true ? (
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Requested Delivery Date</p>
                        </Col>
                        <Col lg={10} md={10} sm={24} xs={24}>
                          <Row gutter={10}>
                            <Col lg={20} md={20} sm={24} xs={24}>
                              <Form.Item className="Formitem">
                                {getFieldDecorator("deliveryDate", {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Please input  Date Delivered!",
                                    },
                                  ],
                                })(
                                  <DatePicker
                                    onChange={this.onChange}
                                    format={dateFormat}
                                  />
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={10}>
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <Form.Item>
                                {getFieldDecorator("deliveryStartTime", {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Please input Start Time!",
                                    },
                                  ],
                                })(
                                  <TimePicker
                                    placeholder="Start Time"
                                    use12Hours
                                    minuteStep={15}
                                    showSecond={false}
                                    focusOnOpen={true}
                                    format="hh:mm A"
                                    className="time-picker"
                                    defaultValue={moment()}
                                    onChange={(value) =>
                                      this.handleStartTime(
                                        value,
                                        "deliveryStartTime"
                                      )
                                    }
                                    disabledHours={this.getStartDisabledHours}
                                    disabledMinutes={
                                      this.getStartDisabledMinutes
                                    }
                                  />
                                )}
                              </Form.Item>
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <Form.Item>
                                {getFieldDecorator("deliveryEndTime", {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Please input End Time",
                                    },
                                  ],
                                })(
                                  <TimePicker
                                    placeholder="End Time"
                                    use12Hours
                                    minuteStep={15}
                                    showSecond={false}
                                    focusOnOpen={true}
                                    format="hh:mm A"
                                    className="time-picker"
                                    defaultValue={moment()}
                                    onChange={(value) =>
                                      this.handleEndTime(
                                        value,
                                        "deliveryEndTime"
                                      )
                                    }
                                    disabledHours={this.getEndDisabledHours}
                                    disabledMinutes={this.getEndDisabledMinutes}
                                  />
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={1} md={1} sm={24} xs={24}>
                          <CheckOutlined
                            title="update"
                            onClick={this.updateDeliveryEdit}
                            style={{
                              fontSize: "1.5em",
                              float: "right",
                              color: "#006400",
                              marginTop: "10px",
                            }}
                          />
                        </Col>
                        <Col lg={1} md={1} sm={24} xs={24}>
                          <CloseOutlined
                            title="Cancel"
                            onClick={() => {
                              this.setState({ deliveryEdit: false });
                            }}
                            style={{
                              fontSize: "1.5em",
                              marginTop: "10px",
                              color: "red",
                              float: "right",
                            }}
                          />
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Requested Delivery Date</p>
                        </Col>
                        {leadData["deliveryReqDate"] && (
                          <Col lg={10} md={10} sm={24} xs={24}>
                            <h3>
                              {leadData["deliveryReqDate"]
                                ? leadData["deliveryReqDate"]
                                : ""}
                              {leadData["deliveryReqDate"] &&
                              leadData["deliveryReqTime"]
                                ? " " + leadData["deliveryReqTime"]
                                : leadData["deliveryReqTime"]
                                ? leadData["deliveryReqTime"]
                                : ""}
                            </h3>
                          </Col>
                        )}
                        {rolePermisions &&
                          rolePermisions[0]?.permissions?.includes(
                            "editOrder"
                          ) && (
                            <Col lg={6} md={6} sm={24} xs={24}>
                              <EditOutlined
                                title="edit"
                                onClick={this.deliveryEdit}
                                style={{ fontSize: "1.4em", float: "right" }}
                              />
                            </Col>
                          )}
                      </Row>
                    )}
                    <Divider />
                    <Row>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        <p>Pickup Location</p>
                      </Col>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        {pickupLocationEdit ? (
                          <Select
                            style={{ width: "100%" }}
                            onChange={(e) =>
                              this.setState({ updatedLoaction: e })
                            }
                            defaultValue={
                              Array.isArray(leadData["productOriginDetails"])
                                ? leadData["productOriginDetails"]?.map(
                                    (item) =>
                                      item["address"] &&
                                      `${item["locationName"]}`
                                  )
                                : leadData["productOriginDetails"]?.[
                                    "address"
                                  ] &&
                                  leadData["productOriginDetails"]?.[
                                    "locationName"
                                  ]
                            }
                            showSearch
                            options={this.state.orgDetails["yardLocations"]}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {this.state.orgDetails["yardLocations"].map(
                              (location, index) => (
                                <Option
                                  key={location.locationName}
                                  value={location.id}
                                >
                                  {location.locationName}
                                </Option>
                              )
                            )}
                          </Select>
                        ) : (
                          <h3>
                            {Array.isArray(leadData["productOriginDetails"])
                              ? leadData["productOriginDetails"]?.map(
                                  (item) =>
                                    item["address"] && `${item["locationName"]}`
                                )
                              : leadData["productOriginDetails"]?.["address"] &&
                                leadData["productOriginDetails"]?.[
                                  "locationName"
                                ]}
                          </h3>
                        )}
                      </Col>
                      <Col
                        lg={4}
                        md={4}
                        sm={24}
                        xs={24}
                        style={{ textAlign: "right" }}
                      >
                        {pickupLocationEdit ? (
                          <>
                            <CheckOutlined
                              title="update"
                              onClick={this.updateLoactionEdit}
                              style={{
                                fontSize: "1.5em",
                                color: "#006400",
                                marginTop: "10px",
                                ma1rginRight: "10px",
                              }}
                            />
                            <CloseOutlined
                              title="Cancel"
                              onClick={() => {
                                this.setState({ pickupLocationEdit: false });
                              }}
                              style={{
                                fontSize: "1.5em",
                                marginTop: "10px",
                                color: "red",
                              }}
                            />
                          </>
                        ) : (
                          <h3>
                            {leadData["orderStatus"] !==
                              AppConfigs["DELIVERED"] &&
                              leadData["orderStatus"] !==
                                AppConfigs["CANCELLED"] &&
                              rolePermisions &&
                              rolePermisions[0]?.permissions?.includes(
                                "editOrder"
                              ) && (
                                <EditOutlined
                                  onClick={() => {
                                    this.setState({
                                      pickupLocationEdit: true,
                                    });
                                  }}
                                  title="edit"
                                  style={{ fontSize: "1.4em" }}
                                />
                              )}
                          </h3>
                        )}
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        <p>Estimated Date & time</p>
                      </Col>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <h3>
                          {leadData["pickupDate"] &&
                            leadData["pickupStartTime"] &&
                            leadData["pickupEndTime"] &&
                            moment(leadData["pickupDate"]).format(
                              "MM/DD/YYYY"
                            ) +
                              "  " +
                              leadData["pickupStartTime"] +
                              " - " +
                              leadData["pickupEndTime"]}
                        </h3>
                      </Col>
                    </Row>
                    <Divider />
                    {locationEdit === true ? (
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Delivery Location</p>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item className="Formitem">
                            {getFieldDecorator("customerLocation", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please Select your Customer Name!",
                                },
                              ],
                            })(
                              <Select style={{ width: "100%" }}>
                                {locations.map((location, index) => (
                                  <Option key={location} value={location}>
                                    {location}
                                  </Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>

                        <Col
                          lg={4}
                          md={4}
                          sm={24}
                          xs={24}
                          style={{ textAlign: "right" }}
                        >
                          <CheckOutlined
                            title="update"
                            onClick={this.updateLocationEdit}
                            style={{
                              fontSize: "1.5em",
                              color: "#006400",
                              marginTop: "10px",
                              marginRight: "10px",
                            }}
                          />
                          <CloseOutlined
                            title="Cancel"
                            onClick={() => {
                              this.setState({ locationEdit: false });
                            }}
                            style={{
                              fontSize: "1.5em",
                              marginTop: "10px",
                              color: "red",
                            }}
                          />
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Delivery Location</p>
                        </Col>
                        <Col lg={14} md={14} sm={24} xs={24}>
                          <h3>
                            {leadData["address"] &&
                              leadData["cartItems"][0]["locationName"]}
                          </h3>
                        </Col>
                        <Col lg={2} md={2} sm={24} xs={24}>
                          {leadData["address"] &&
                            rolePermisions &&
                            rolePermisions[0]?.permissions?.includes(
                              "editOrder"
                            ) && (
                              <EditOutlined
                                onClick={() => {
                                  this.locationEdit(
                                    leadData["cartItems"][0]["locationName"]
                                  );
                                }}
                                title="edit"
                                style={{ fontSize: "1.4em", float: "right" }}
                              />
                            )}
                        </Col>
                      </Row>
                    )}
                    <Divider />
                    <Row>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        <p>Distance</p>
                      </Col>
                      <Col lg={10} md={10} sm={24} xs={24}>
                        <h3>
                          {isNaN(leadData["distanceMiles"]) ||
                          leadData["distanceMiles"] === null
                            ? ""
                            : leadData["distanceMiles"] + " miles"}
                        </h3>
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        <p>PO#</p>
                      </Col>
                      {/* console log out the leadData */}

                      <Col lg={10} md={10} sm={24} xs={24}>
                        <h3>
                          {isNaN(leadData["poNumber"]) ||
                          leadData["poNumber"] === null
                            ? ""
                            : leadData["poNumber"]}
                        </h3>
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        <p>Order Notes</p>
                      </Col>
                      {!notesEdit ? (
                        <>
                          <Col lg={14} md={14} sm={24} xs={24}>
                            <h3>{leadData["notes"] && leadData["notes"]}</h3>
                          </Col>
                          <Col lg={2} md={2} sm={2} xs={2}>
                            <h3>
                              {rolePermisions &&
                                rolePermisions[0]?.permissions?.includes(
                                  "editOrder"
                                ) && (
                                  <EditOutlined
                                    onClick={() => {
                                      this.setState({ notesEdit: true });
                                    }}
                                    title="edit"
                                    style={{
                                      fontSize: "1.4em",
                                      float: "right",
                                    }}
                                  />
                                )}
                            </h3>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col lg={14} md={14} sm={24} xs={24}>
                            <Form.Item className="Formitem">
                              {getFieldDecorator("customerNotes", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please input notes!",
                                  },
                                ],
                                initialValue: leadData["notes"],
                              })(<TextArea style={{ height: "60px" }} />)}
                            </Form.Item>
                          </Col>
                          <Col lg={1} md={1} sm={24} xs={24}>
                            <CheckOutlined
                              title="update"
                              onClick={() =>
                                this.updateNotesEdit("customerNotes")
                              }
                              style={{
                                fontSize: "1.5em",
                                float: "right",
                                color: "#006400",
                                marginTop: "20px",
                              }}
                            />
                          </Col>
                          <Col lg={1} md={1} sm={24} xs={24}>
                            <CloseOutlined
                              title="Cancel"
                              onClick={() => {
                                this.setState({ notesEdit: false });
                              }}
                              style={{
                                fontSize: "1.5em",
                                marginTop: "20px",
                                color: "red",
                                float: "right",
                              }}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                    <Divider />
                    <Row>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        <p>PickUp Notes</p>
                      </Col>
                      {!defeoNotesEdit ? (
                        <>
                          <Col lg={14} md={14} sm={24} xs={24}>
                            <h3>
                              {leadData &&
                                leadData["cartItems"]?.[0]["defeoNotes"]}
                            </h3>
                          </Col>
                          <Col lg={2} md={2} sm={2} xs={2}>
                            <h3>
                              {rolePermisions &&
                                rolePermisions[0]?.permissions?.includes(
                                  "editOrder"
                                ) && (
                                  <EditOutlined
                                    onClick={() => {
                                      this.setState({ defeoNotesEdit: true });
                                    }}
                                    title="edit"
                                    style={{
                                      fontSize: "1.4em",
                                      float: "right",
                                    }}
                                  />
                                )}
                            </h3>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col lg={14} md={14} sm={24} xs={24}>
                            <Form.Item className="Formitem">
                              {getFieldDecorator("defeoNotes", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please input Order notes !",
                                  },
                                ],
                                initialValue:
                                  leadData &&
                                  leadData["cartItems"]?.[0]["defeoNotes"],
                              })(<TextArea style={{ height: "60px" }} />)}
                            </Form.Item>
                          </Col>
                          <Col lg={1} md={1} sm={24} xs={24}>
                            <CheckOutlined
                              title="update"
                              onClick={() => this.updateNotesEdit("defeoNotes")}
                              style={{
                                fontSize: "1.5em",
                                float: "right",
                                color: "#006400",
                                marginTop: "20px",
                              }}
                            />
                          </Col>
                          <Col lg={1} md={1} sm={24} xs={24}>
                            <CloseOutlined
                              title="Cancel"
                              onClick={() => {
                                this.setState({ defeoNotesEdit: false });
                              }}
                              style={{
                                fontSize: "1.5em",
                                marginTop: "20px",
                                color: "red",
                                float: "right",
                              }}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                    <Divider />

                    <Row>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        <p>Tags</p>
                      </Col>
                      {!tagsEdit ? (
                        <>
                          <Col lg={14} md={14} sm={24} xs={24}>
                            <h3>
                              {leadData["tagNames"] &&
                                leadData["tagNames"].join(", ")}
                            </h3>
                          </Col>
                          {AppConfigs["PUSH_TO_CARRIER"] ===
                            leadData["orderStatus"] && (
                            <Col lg={2} md={2} sm={2} xs={2}>
                              <h3>
                                {
                                  <EditOutlined
                                    onClick={() => {
                                      this.setState({ tagsEdit: true });
                                    }}
                                    title="edit"
                                    style={{
                                      fontSize: "1.4em",
                                      float: "right",
                                    }}
                                  />
                                }
                              </h3>
                            </Col>
                          )}
                        </>
                      ) : (
                        <>
                          <Col lg={14} md={14} sm={24} xs={24}>
                            <Form.Item className="Formitem">
                              {getFieldDecorator("tags", {
                                rules: [{ type: "array" }],
                                initialValue: leadData["tags"],
                              })(
                                <Select
                                  mode="multiple"
                                  allowClear
                                  style={{ width: "100%" }}
                                  placeholder="Please Select"
                                  showArrow
                                >
                                  {masterData
                                    .sort((a, b) =>
                                      a["name"] > b["name"] ? 1 : -1
                                    )
                                    .map((tag) => (
                                      <Option value={tag.id} key={tag.id}>
                                        {tag.name}
                                      </Option>
                                    ))}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                          <Col lg={2} md={2} sm={24} xs={24}>
                            <CheckOutlined
                              title="update"
                              onClick={this.updateTags}
                              style={{
                                fontSize: "1.5em",
                                float: "right",
                                marginTop: "5px",
                                color: "#006400",
                              }}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                    {/* <Divider />
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Rate </p>
                        </Col>
                        <Col lg={14} md={14} sm={24} xs={24}>
                          <div>
                            {leadData["callForRate"] ? (
                              <h3>Call for Rate</h3>
                            ) : (
                              leadData["rateAmt"] && (
                                <h3>
                                  ${leadData["rateAmt"]} /{" "}
                                  {leadData["rateOption"]}
                                </h3>
                              )
                            )}
                          </div>
                        </Col>
                        <Col lg={2} md={2} sm={24} xs={24}>
                          <h3>
                            {(leadData["rateAmt"] ||
                              leadData["callForRate"] ||
                              !leadData["callForRate"]) &&
                              leadData["orderStatus"] !==
                                AppConfigs["DELIVERED"] &&
                              leadData["orderStatus"] !==
                                AppConfigs["CANCELLED"] &&
                              rolePermisions &&
                              rolePermisions[0]?.permissions?.includes(
                                "editOrder"
                              ) && (
                                <EditOutlined
                                  onClick={() => {
                                    this.setState({
                                      rateModal: true,
                                      callForRateValue: leadData["callForRate"],
                                    });
                                  }}
                                  title="edit"
                                  style={{ fontSize: "1.4em", float: "right" }}
                                />
                              )}
                          </h3>
                        </Col>
                      </Row> */}
                  </Card>
                </div>
              </Col>

              <Col lg={7} md={7} sm={24} xs={24}>
                {leadData["assignCarrier"] ? (
                  <div className="site-card-border-less-wrapper">
                    <Card
                      title="Carrier Details"
                      style={{ borderRadius: "10px", height: "600px" }}
                    >
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Company</p>
                        </Col>
                        <Col lg={10} md={10} sm={24} xs={24}>
                          <h3>{leadData["carrierDetails"]["carrierName"]}</h3>
                        </Col>
                      </Row>

                      <Divider />
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Rate for Load</p>
                        </Col>
                        <Col lg={14} md={14} sm={24} xs={24}>
                          <div>
                            {leadData["callForRate"] ? (
                              <h3>Call for Rate</h3>
                            ) : (
                              leadData["rateAmt"] && (
                                <h3>
                                  ${leadData["rateAmt"]} /{" "}
                                  {leadData["rateOption"]}
                                </h3>
                              )
                            )}
                          </div>
                        </Col>
                        <Col lg={2} md={2} sm={24} xs={24}>
                          <h3>
                            {(leadData["rateAmt"] ||
                              leadData["callForRate"] ||
                              !leadData["callForRate"]) &&
                              leadData["orderStatus"] !==
                                AppConfigs["DELIVERED"] &&
                              leadData["orderStatus"] !==
                                AppConfigs["CANCELLED"] &&
                              rolePermisions &&
                              rolePermisions[0]?.permissions?.includes(
                                "editOrder"
                              ) && (
                                <EditOutlined
                                  onClick={() => {
                                    this.setState({
                                      rateModal: true,
                                      callForRateValue: leadData["callForRate"],
                                    });
                                  }}
                                  title="edit"
                                  style={{ fontSize: "1.4em", float: "right" }}
                                />
                              )}
                          </h3>
                        </Col>
                      </Row>
                      <Divider />
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Truck Type</p>
                        </Col>
                        <Col lg={14} md={14} sm={24} xs={24}>
                          <h3>
                            {leadData["deliveryTruck"] &&
                              leadData["deliveryTruck"]}
                          </h3>
                        </Col>
                      </Row>
                      <Divider />
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Truck Number</p>
                        </Col>
                        <Col lg={14} md={14} sm={24} xs={24}>
                          {/* <h3>{leadData["driverDetails"] && leadData["driverDetails"]["truckNumber"]}</h3> */}
                          {/* <h3>{leadData["truckDetails"] && leadData["truckDetails"]["typeOfTruck"] + " - " + leadData["truckDetails"]["truckNumber"] }</h3> */}
                          <h3>
                            {leadData && leadData["truckDetails"]
                              ? leadData["truckDetails"]["typeOfTruck"] +
                                  " - " +
                                  leadData["truckDetails"] &&
                                leadData["truckDetails"]["truckNumber"]
                              : leadData["driverDetails"] &&
                                leadData["driverDetails"]["truckNumber"]
                              ? leadData["driverDetails"] &&
                                leadData["driverDetails"]["truckNumber"]
                              : leadData["truckNumber"]}
                          </h3>
                        </Col>
                      </Row>
                      <Divider />
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Driver Name</p>
                        </Col>
                        <Col lg={14} md={14} sm={24} xs={24}>
                          <h3>
                            {leadData["driverDetails"] &&
                              leadData["driverDetails"]["name"]}
                          </h3>
                        </Col>
                      </Row>
                      <Divider />
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Driver Contact</p>
                        </Col>
                        <Col lg={14} md={14} sm={24} xs={24}>
                          {leadData["driverDetails"] &&
                            leadData["driverDetails"]["phone"] && (
                              <span className="contactdetails">
                                {leadData["driverDetails"] &&
                                  formatPhoneNumber(
                                    leadData["driverDetails"]["phone"].slice(2)
                                  )}
                              </span>
                            )}
                        </Col>
                      </Row>
                      <Divider />
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Load Pickup Date</p>
                        </Col>

                        <Col lg={14} md={14} sm={24} xs={24}>
                          <h3>
                            {leadData["pickupDate"] && leadData["pickupDate"]}
                            {leadData["pickupStartTime"] &&
                              " " + leadData["pickupStartTime"]}
                            {leadData["pickupEndTime"] &&
                              " - " + leadData["pickupEndTime"]}
                          </h3>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Delivery Date</p>
                        </Col>
                        <Col lg={10} md={10} sm={24} xs={24}>
                          <h3>{leadData["deliveryDateAndTime"]}</h3>
                        </Col>
                      </Row>
                      <Divider />
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Delivery Notes</p>
                        </Col>
                        {!deliveryNotesEdit ? (
                          <>
                            <Col lg={14} md={14} sm={24} xs={24}>
                              <h3>
                                {leadData["carrierDetails"] &&
                                leadData["carrierDetails"]["carrierNotes"]
                                  ? leadData["carrierDetails"]["carrierNotes"]
                                  : ""}
                              </h3>
                            </Col>
                            <Col lg={2} md={2} sm={2} xs={2}>
                              <h3>
                                {rolePermisions &&
                                  rolePermisions[0]?.permissions?.includes(
                                    "editOrder"
                                  ) && (
                                    <EditOutlined
                                      onClick={() => {
                                        this.setState({
                                          deliveryNotesEdit: true,
                                        });
                                      }}
                                      title="edit"
                                      style={{
                                        fontSize: "1.4em",
                                        float: "right",
                                      }}
                                    />
                                  )}
                              </h3>
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <Form.Item className="Formitem">
                                {getFieldDecorator("deliveryNotes", {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Please input Delivery Notes !",
                                    },
                                  ],
                                  initialValue:
                                    leadData["carrierDetails"] &&
                                    leadData["carrierDetails"]["carrierNotes"]
                                      ? leadData["carrierDetails"][
                                          "carrierNotes"
                                        ]
                                      : "",
                                })(
                                  <TextArea
                                    style={{ height: "60px", width: "90%" }}
                                  />
                                )}
                              </Form.Item>
                            </Col>
                            <Col lg={1} md={1} sm={24} xs={24}>
                              <CheckOutlined
                                title="update"
                                onClick={() =>
                                  this.updateNotesEdit("deliveryNotes")
                                }
                                style={{
                                  fontSize: "1.5em",
                                  float: "right",
                                  color: "#006400",
                                  marginTop: "20px",
                                }}
                              />
                            </Col>
                            <Col
                              lg={1}
                              md={1}
                              sm={24}
                              xs={24}
                              style={{
                                marginLeft: "10px",
                              }}
                            >
                              <CloseOutlined
                                title="Cancel"
                                onClick={() => {
                                  this.setState({ deliveryNotesEdit: false });
                                }}
                                style={{
                                  fontSize: "1.5em",
                                  marginTop: "20px",
                                  marginLeft: "10px",
                                  color: "red",
                                  float: "right",
                                }}
                              />
                            </Col>
                          </>
                        )}
                      </Row>
                      {/* <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <p>Delivery Notes</p>
                        </Col>
                        <Col lg={14} md={14} sm={24} xs={24}>
                          <h3>
                            {leadData["carrierDetails"] &&
                            leadData["carrierDetails"]["carrierNotes"]
                              ? leadData["carrierDetails"]["carrierNotes"]
                              : ""}
                          </h3>
                        </Col>
                      </Row> */}

                      {/* {leadData["leadDeliveryImage"] ?

                         <Row>
                          <Col lg={8} md={8} sm={24} xs={24}>
                              <p >Load Delivered Image</p>
                          </Col>
                          <Col lg={10} md={10} sm={24} xs={24}>
                             <div style={{ float: 'right' }}>
                                <img src={deliveryImage} alt="avatar" style={{ width: '120px', height: '120px', objectFit: 'cover', marginTop: '2%' }} />
                                <p style={{ marginTop: '10%', cursor: 'pointer', textDecoration: 'underline' }} onClick={()=>{this.fileDownload(leadData["leadDeliveryImage"])}}>Download Image</p>
                                 </div>
                               </Col>
                                </Row>
                                   :                                                ""
                                           } */}
                    </Card>
                  </div>
                ) : (
                  <div className="site-card-border-less-wrapper">
                    {leadData.customerLatLng &&
                      this.state.productLocations[0]?.latLng && (
                        <Card style={{ borderRadius: "10px" }}>
                          <MapDirection
                            lat={leadData?.customerLatLng?.lat}
                            lng={leadData?.customerLatLng?.lng}
                            source={this.state.productLocations[0]?.latLng}
                            isMarkerShown
                          />
                        </Card>
                      )}
                  </div>
                )}
              </Col>

              <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: "2%" }}>
                <div className="site-card-border-less-wrapper">
                  <Card style={{ borderRadius: "10px" }}>
                    <div>
                      <Row>
                        <h1
                          style={{
                            float: "left",
                            color: "#000000d9",
                            fontWeight: "500",
                            fontSize: "16px",
                          }}
                        >
                          Product Details
                        </h1>
                      </Row>
                      <Divider />
                      <Table
                        columns={columns}
                        dataSource={
                          leadData["cartItems"]
                            ? leadData["cartItems"]
                            : leadData["items"]
                            ? leadData["items"]
                            : []
                        }
                        pagination={false}
                        loading={dataLoadingStatus}
                        style={{ marginTop: "2%", overflowX: "auto" }}
                        rowKey={(record) => record.id}
                      />
                      <div style={{ marginTop: "2%" }}>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <p
                            style={{
                              color: "black",
                              fontSize: "15px",
                              float: "left",
                            }}
                          >
                            Status:&nbsp;
                            <span className="status_tag">
                              <Tag
                                color={
                                  AppConfigs["STATUS_COLORS"][
                                    leadData["orderStatus"]
                                  ]
                                }
                                style={{
                                  color: "black",
                                  height: "27px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                {leadData.deliveryTruck &&
                                (leadData.deliveryTruck.includes(
                                  "Customer Pickup"
                                ) ||
                                  leadData.deliveryTruck ===
                                    "CustomerPickup") &&
                                leadData["orderStatus"] === "OP"
                                  ? "Pending Customer Pickup"
                                  : leadData.deliveryTruck &&
                                    (leadData.deliveryTruck.includes(
                                      "Customer Pickup"
                                    ) ||
                                      leadData.deliveryTruck ===
                                        "CustomerPickup") &&
                                    leadData["orderStatus"] === "D"
                                  ? "Customer Picked Up"
                                  : AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][
                                      leadData["orderStatus"]
                                    ]}
                              </Tag>
                            </span>
                          </p>
                        </Col>
                        {leadData["measurementType"] === "Pallet" && (
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <p style={{ float: "right" }}>
                              Delivery Fee:&nbsp;
                              <span
                                style={{ color: "black", fontSize: "15px" }}
                              >
                                {leadData["deliveryAmt"] && (
                                  <NumberFormat
                                    value={parseFloat(
                                      leadData["deliveryAmt"]
                                    ).toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                  />
                                )}
                              </span>
                            </p>
                          </Col>
                        )}

                        <Col lg={12} md={12} sm={24} xs={24}>
                          <p style={{ float: "right" }}>
                            Total Amount:&nbsp;
                            <span style={{ color: "black", fontSize: "15px" }}>
                              {leadData["totalAmt"] && (
                                <NumberFormat
                                  value={parseFloat(totalAmount).toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                />
                              )}
                            </span>
                          </p>
                        </Col>
                      </div>
                    </div>
                  </Card>
                </div>
              </Col>

              <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: "2%" }}>
                <div className="site-card-border-less-wrapper">
                  <Card style={{ borderRadius: "10px" }}>
                    <div>
                      <Row>
                        <h1
                          style={{
                            float: "left",
                            color: "#000000d9",
                            fontWeight: "500",
                            fontSize: "16px",
                          }}
                        >
                          Audit Trail
                        </h1>
                      </Row>
                      <Divider />
                      <Table
                        columns={auditColumns}
                        dataSource={auditDetails}
                        pagination={false}
                        loading={dataLoadingStatus}
                        style={{ marginTop: "2%", overflowX: "auto" }}
                        rowKey={(record) => record.id}
                      />
                    </div>
                  </Card>
                </div>
              </Col>

              <Col lg={7} md={7} sm={24} xs={24} style={{ marginTop: "2%" }}>
                {leadData["deliveryTruck"] !== "CustomerPickup" && (
                  <div>
                    <div className="site-card-border-less-wrapper">
                      <Card
                        title="Load Details"
                        style={{ borderRadius: "10px" }}
                      >
                        <Row>
                          <Col lg={8} md={8} sm={24} xs={24}>
                            <p>Ticket Number</p>
                          </Col>

                          {ticketEdit ? (
                            <Col lg={10} md={10} sm={24} xs={24}>
                              <Form.Item className="Formitem">
                                {getFieldDecorator("tNumber", {
                                  rules: [
                                    {
                                      required: true,
                                      message:
                                        "Please input your Ticket Number!",
                                    },
                                  ],
                                  initialValue:
                                    leadData["ticketNumber"] &&
                                    leadData["ticketNumber"],
                                })(
                                  <Input onChange={this.handleWeightChanges} />
                                )}
                              </Form.Item>
                            </Col>
                          ) : (
                            <Col lg={10} md={10} sm={24} xs={24}>
                              <h3>
                                {leadData["ticketNumber"] &&
                                  leadData["ticketNumber"]}
                              </h3>
                            </Col>
                          )}
                          <Col
                            lg={6}
                            md={6}
                            sm={24}
                            xs={24}
                            style={{ textAlign: "right" }}
                          >
                            {ticketEdit ? (
                              <>
                                <CheckOutlined
                                  title="update"
                                  onClick={() => {
                                    this.setState({ ticketEdit: false });
                                    this.updateWeightEdit("ticket");
                                  }}
                                  style={{
                                    fontSize: "1.5em",
                                    color: "#006400",
                                    marginTop: "5px",
                                  }}
                                />
                                <CloseOutlined
                                  title="Cancel"
                                  onClick={() => {
                                    this.setState({ ticketEdit: false });
                                  }}
                                  style={{
                                    fontSize: "1.5em",
                                    marginTop: "5px",
                                    color: "red",
                                  }}
                                />
                              </>
                            ) : (
                              <EditOutlined
                                title="edit"
                                onClick={() =>
                                  this.setState({
                                    ticketEdit: true,
                                  })
                                }
                                style={{
                                  fontSize: "1.4em",
                                  float: "right",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </Col>
                        </Row>
                        <Divider style={{ margin: "6px" }} />
                        <Row>
                          <Col lg={8} md={8} sm={24} xs={24}>
                            <p>Gross Weight</p>
                          </Col>
                          {gWeightEdit ? (
                            <Col lg={10} md={10} sm={24} xs={24}>
                              <Form.Item className="Formitem">
                                {getFieldDecorator("grossWeight", {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Please input the gross weight!",
                                    },
                                  ],
                                  initialValue:
                                    leadData["weight"] &&
                                    leadData["weight"]["grossWeight"],
                                })(
                                  <Input
                                    onChange={this.handleWeightChanges}
                                    type="number"
                                  />
                                )}
                              </Form.Item>
                            </Col>
                          ) : (
                            <Col lg={10} md={10} sm={24} xs={24}>
                              {leadData["weight"] &&
                                leadData["weight"]["grossWeight"] && (
                                  <h3>
                                    <NumberFormat
                                      value={parseInt(
                                        leadData["weight"]["grossWeight"]
                                      )}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                    />
                                  </h3>
                                )}
                            </Col>
                          )}

                          <Col
                            lg={6}
                            md={6}
                            sm={24}
                            xs={24}
                            style={{ textAlign: "right" }}
                          >
                            {gWeightEdit ? (
                              <>
                                <CheckOutlined
                                  title="update"
                                  onClick={() => {
                                    this.setState({ gWeightEdit: false });
                                    this.updateWeightEdit();
                                  }}
                                  style={{
                                    fontSize: "1.5em",
                                    color: "#006400",
                                    marginTop: "5px",
                                  }}
                                />
                                <CloseOutlined
                                  title="Cancel"
                                  onClick={() => {
                                    this.setState({ gWeightEdit: false });
                                  }}
                                  style={{
                                    fontSize: "1.5em",
                                    marginTop: "5px",
                                    color: "red",
                                  }}
                                />
                              </>
                            ) : (
                              <EditOutlined
                                title="edit"
                                onClick={() =>
                                  this.setState({
                                    gWeightEdit: true,
                                  })
                                }
                                style={{
                                  fontSize: "1.4em",
                                  float: "right",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </Col>
                        </Row>
                        <Divider style={{ margin: "6px" }} />

                        <Row>
                          <Col lg={8} md={8} sm={24} xs={24}>
                            <p>Tare Weight</p>
                          </Col>
                          {tWeightEdit ? (
                            <Col lg={10} md={10} sm={24} xs={24}>
                              <Form.Item className="Formitem">
                                {getFieldDecorator("tareWeight", {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Please input the tare weight!",
                                    },
                                  ],
                                  initialValue:
                                    leadData["weight"] &&
                                    leadData["weight"]["tareWeight"],
                                })(
                                  <Input
                                    onChange={this.handleWeightChanges}
                                    type="number"
                                  />
                                )}
                              </Form.Item>
                            </Col>
                          ) : (
                            <Col lg={10} md={10} sm={24} xs={24}>
                              {leadData["weight"] &&
                                leadData["weight"]["tareWeight"] && (
                                  <h3>
                                    <NumberFormat
                                      value={parseInt(
                                        leadData["weight"]["tareWeight"]
                                      )}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                    />
                                  </h3>
                                )}
                            </Col>
                          )}

                          <Col
                            lg={6}
                            md={6}
                            sm={24}
                            xs={24}
                            style={{ textAlign: "right" }}
                          >
                            {tWeightEdit ? (
                              <>
                                <CheckOutlined
                                  title="update"
                                  onClick={() => {
                                    this.setState({ tWeightEdit: false });
                                    this.updateWeightEdit();
                                  }}
                                  style={{
                                    fontSize: "1.5em",
                                    color: "#006400",
                                    marginTop: "5px",
                                  }}
                                />
                                <CloseOutlined
                                  title="Cancel"
                                  onClick={() => {
                                    this.setState({ tWeightEdit: false });
                                  }}
                                  style={{
                                    fontSize: "1.5em",
                                    marginTop: "5px",
                                    color: "red",
                                  }}
                                />
                              </>
                            ) : (
                              <EditOutlined
                                title="edit"
                                onClick={() =>
                                  this.setState({
                                    tWeightEdit: true,
                                  })
                                }
                                style={{
                                  fontSize: "1.4em",
                                  float: "right",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </Col>
                        </Row>
                        <Divider style={{ margin: "6px" }} />
                        {leadData["weight"] && (
                          <Row>
                            <Col lg={8} md={8} sm={24} xs={24}>
                              <p>Net Weight</p>
                            </Col>

                            <Col lg={10} md={10} sm={24} xs={24}>
                              <h3>
                                <NumberFormat
                                  value={parseInt(
                                    leadData["weight"]["grossWeight"] -
                                      leadData["weight"]["tareWeight"]
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  hundreSeparator={true}
                                />
                              </h3>
                            </Col>
                          </Row>
                        )}
                      </Card>
                      {/* <Card style={{ borderRadius: "10px" }}>
                        <div>
                          <Row className="detailsborder">
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <h4 className="Companyheadinglabel">
                                Load Delivered Image
                              </h4>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              lg={10}
                              md={10}
                              sm={24}
                              xs={24}
                              style={{ textAlign: "center", marginTop: "6%" }}
                            >
                              {leadData["leadDeliveryImage"] ? (
                                <Spin spinning={uploadCompanyLogoLoading}>
                                  <img
                                    src={delImage}
                                    style={{ width: "100px", height: "100px" }}
                                    alt="logo"
                                  />
                                  <p
                                    style={{
                                      marginTop: "5%",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => {
                                      this.fileDownload(
                                        leadData["leadDeliveryImage"]
                                      );
                                    }}
                                  >
                                    Download Image
                                  </p>
                                </Spin>
                              ) : (
                                ""
                              )}
                            </Col>
                            <Col
                              lg={14}
                              md={14}
                              sm={24}
                              xs={24}
                              style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                            >
                              <Upload {...props} fileList={fileList}>
                                <h2
                                  style={{
                                    color: "#1A5EB9",
                                    marginTop: "60px",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Upload Image
                                </h2>
                              </Upload>
                            </Col>
                          </Row>
                          <Row></Row>
                        </div>
                      </Card> */}
                    </div>
                  </div>
                )}
                {/* {leadData["assignCarrier"] && (
                  <div className="site-card-border-less-wrapper">
                    {leadData.customerLatLng &&
                      this.state?.productLocations[0]?.latLng && (
                        <Card style={{ borderRadius: "10px" }}>
                          <MapDirection
                            lat={leadData?.customerLatLng?.lat}
                            lng={leadData?.customerLatLng?.lng}
                            source={this.state?.productLocations[0]?.latLng}
                            isMarkerShown
                          />
                        </Card>
                      )}
                  </div>
                )} */}
              </Col>

              <Col lg={7} md={7} sm={24} xs={24} style={{ marginTop: "2%" }}>
                {
                  <div>
                    <div className="site-card-border-less-wrapper">
                      <Card style={{ borderRadius: "10px" }}>
                        <div>
                          <Row className="detailsborder">
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <h4 className="Companyheadinglabel">Image</h4>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              lg={10}
                              md={10}
                              sm={24}
                              xs={24}
                              style={{
                                textAlign: "center",
                                marginTop: "6%",
                                float: "inline-end",
                              }}
                            >
                              {this.state.leadData["leadDeliveryImage"] ? (
                                <>
                                  <h3
                                    // className="Companyheadinglabel"
                                    style={{ width: "115px" }}
                                  >
                                    Delivery Pic
                                  </h3>
                                  <Card
                                    hoverable
                                    style={{ width: "140px" }}
                                    cover={
                                      <img
                                        // src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png"
                                        src={
                                          this.state.delImage &&
                                          this.state.delImage.includes(".pdf")
                                            ? Docsample
                                            : this.state.delImage
                                        }
                                        alt="Delivery Pic"
                                        style={{
                                          width: "130px",
                                          height: "130px",
                                        }}
                                      />
                                    }
                                  >
                                    <Button
                                      key="submit"
                                      style={{
                                        width: "120px",
                                        marginLeft: "-15px",
                                      }}
                                      loading={
                                        this.state.downloadDeliveryPicLoading
                                      }
                                      disabled={!this.state.delImage?.length}
                                      onClick={() => {
                                        this.setState({
                                          downloadDeliveryPicLoading: true,
                                        });
                                        this.fileDownload(
                                          this.state.leadData[
                                            "leadDeliveryImage"
                                          ]?.delivery_pic
                                        );
                                      }}
                                    >
                                      Download
                                    </Button>
                                  </Card>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                            <Col
                              lg={10}
                              md={10}
                              sm={24}
                              xs={24}
                              style={{ textAlign: "center", marginTop: "6%" }}
                            >
                              {this.state.leadData["leadDeliveryImage"] ? (
                                <>
                                  <h3
                                    // className="Companyheadinglabel"
                                    style={{
                                      width: "115px",
                                      marginLeft: "30px",
                                    }}
                                  >
                                    Delivery Ticket
                                  </h3>
                                  <Card
                                    hoverable
                                    style={{
                                      width: "140px",
                                      marginLeft: "30px",
                                    }}
                                    cover={
                                      <img
                                        // src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png"
                                        src={
                                          this.state.delTicket &&
                                          this.state.delTicket.includes(".pdf")
                                            ? Docsample
                                            : this.state.delTicket
                                        }
                                        // src={this.state.delTicket}
                                        alt="Delivery Ticket"
                                        style={{
                                          width: "130px",
                                          height: "130px",
                                        }}
                                      />
                                    }
                                  >
                                    <Button
                                      key="submit"
                                      style={{
                                        width: "120px",
                                        marginLeft: "-15px",
                                      }}
                                      loading={
                                        this.state.downloadDeliveryTicketLoading
                                      }
                                      disabled={!this.state.delTicket?.length}
                                      onClick={() => {
                                        this.setState({
                                          downloadDeliveryTicketLoading: true,
                                        });
                                        this.fileDownload(
                                          this.state.leadData[
                                            "leadDeliveryImage"
                                          ]?.delivery_ticket_pic
                                        );
                                      }}
                                    >
                                      Download
                                    </Button>
                                  </Card>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                          <Row>
                            {" "}
                            <Col
                              lg={14}
                              md={14}
                              sm={24}
                              xs={24}
                              style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                            >
                              {/* <Spin spinning={this.state.uploadCompanyLogoLoading}> */}
                              {/* <Upload {...props} fileList={this.state.fileList}>
                                <h2
                                  style={{
                                    color: "#1A5EB9",
                                    marginTop: "60px",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Upload Image
                                </h2>
                              </Upload> */}
                              {/* </Spin> */}
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    </div>
                  </div>
                }
              </Col>
              <Col lg={7} md={7} sm={24} xs={24} style={{ marginTop: "2%" }}>
                {
                  <div>
                    <div className="site-card-border-less-wrapper">
                      <Card style={{ borderRadius: "10px" }}>
                        <div>
                          <Row className="detailsborder">
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <h4 className="Companyheadinglabel">
                                Order Document
                              </h4>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              lg={20}
                              md={20}
                              sm={24}
                              xs={24}
                              style={{
                                textAlign: "center",
                                marginTop: "6%",
                                float: "inline-end",
                              }}
                            >
                              {this.state.orderDocument ? (
                                <>
                                  <Card
                                    hoverable
                                    style={{ width: "140px" }}
                                    cover={
                                      <img
                                        // src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png"
                                        src={
                                          this.state.orderDocument &&
                                          this.state.orderDocument.includes(
                                            ".pdf"
                                          )
                                            ? Docsample
                                            : this.state.orderDocument
                                        }
                                        alt="Order Document"
                                        style={{
                                          width: "130px",
                                          height: "130px",
                                        }}
                                      />
                                    }
                                  >
                                    <Button
                                      key="submit"
                                      style={{
                                        width: "120px",
                                        marginLeft: "-15px",
                                      }}
                                      loading={
                                        this.state.downloadDeliveryPicLoading
                                      }
                                      disabled={
                                        !this.state.leadData?.cartItems?.[0]
                                          ?.orderDocument?.length
                                      }
                                      onClick={() => {
                                        this.setState({
                                          downloadDeliveryPicLoading: true,
                                        });
                                        this.fileDownload(
                                          this.state.leadData?.cartItems?.[0]
                                            ?.orderDocument
                                        );
                                      }}
                                    >
                                      Download
                                    </Button>
                                  </Card>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                          <Row>
                            {" "}
                            <Col
                              lg={14}
                              md={14}
                              sm={24}
                              xs={24}
                              style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                            >
                              {/* <Spin spinning={this.state.uploadCompanyLogoLoading}> */}
                              {/* <Upload {...props} fileList={this.state.fileList}>
                                <h2
                                  style={{
                                    color: "#1A5EB9",
                                    marginTop: "60px",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Upload Image
                                </h2>
                              </Upload> */}
                              {/* </Spin> */}
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    </div>
                  </div>
                }
              </Col>
            </Row>

            <Form>
              <Modal
                className="modal-black-close"
                visible={productModal}
                title="Edit Product"
                onCancel={() =>
                  this.setState({
                    productModal: false,
                  })
                }
                footer={[
                  <Button
                    key="back"
                    className="cancel"
                    onClick={() => {
                      this.setState({ productModal: false });
                    }}
                  >
                    Cancel
                  </Button>,
                  <Button
                    key="submit"
                    className="assigning"
                    loading={productUpdateLoading}
                    onClick={this.updateProduct}
                  >
                    Update
                  </Button>,
                ]}
              >
                <FormItem>
                  <div>
                    {/* <h3>{leadData["quantity"]}</h3> */}
                    <Row gutter={10}>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span
                              style={{ color: "#7B8190", fontSize: "14px" }}
                            >
                              Product Name
                            </span>
                          }
                        >
                          {getFieldDecorator("productName", {
                            rules: [
                              {
                                required: true,
                                message: "Please input your productName!",
                              },
                            ],
                          })(
                            <Select
                              placeholder={"product"}
                              onChange={(value) => {
                                this.selectProduct(value);
                              }}
                              style={{ width: "100%" }}
                            >
                              {productsData.map((product) => (
                                <Option value={product.id} key={product.id}>
                                  {product.productName}
                                </Option>
                              ))}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span
                              style={{ color: "#7B8190", fontSize: "14px" }}
                            >
                              Size
                            </span>
                          }
                        >
                          {getFieldDecorator("size", {
                            rules: [
                              {
                                required: true,
                                message: "Please input product size!",
                              },
                            ],
                          })(
                            <Select
                              placeholder={"product size"}
                              onChange={(value) =>
                                this.changeFiled(value, "size")
                              }
                              // onChange={(value) => { this.selectProduct(value, leadData["id"]) }}
                              style={{ width: "100%" }}
                            >
                              {selectedProduct["sizes"] &&
                                selectedProduct["sizes"].length > 0 &&
                                selectedProduct["sizes"].map((size) => (
                                  <Option value={size.size} key={size.size}>
                                    {size.size}
                                  </Option>
                                ))}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      {leadData["measurementType"] === "Pallet" ? (
                        <>
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Quantity
                                </span>
                              }
                            >
                              {getFieldDecorator("quantity", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please input your quantity!",
                                  },
                                ],
                              })(
                                <Input
                                  type="number"
                                  placeholder="#"
                                  step={1}
                                  min={1}
                                  onChange={(e) =>
                                    this.changeFiled(e.target.value, "quantity")
                                  }
                                />
                              )}
                            </Form.Item>
                          </Col>
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Measurement
                                </span>
                              }
                            >
                              {getFieldDecorator("measurementType", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please input your Measurment!",
                                  },
                                ],
                              })(
                                <Select
                                  placeholder={"Measurment"}
                                  onChange={(value) =>
                                    this.changeFiled(value, "measurementType")
                                  }
                                  style={{ width: "100%" }}
                                >
                                  <Option value="Pallet">Pallet</Option>
                                  {/* <Option value="Truckload">Truckload</Option> */}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                    </Row>

                    <Row gutter={10}>
                      {leadData["measurementType"] === "Pallet" ? (
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span
                                style={{ color: "#7B8190", fontSize: "14px" }}
                              >
                                Type of Truck
                              </span>
                            }
                          >
                            {getFieldDecorator("deliveryTruck", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Type of Truck!",
                                },
                              ],
                            })(
                              <Select
                                placeholder={"Delivery Truck"}
                                style={{ width: "100%" }}
                                >
                                <Option value="Flatbed">Flatbed</Option>

                                <Option value="Flatbed with forklift">
                                  Flatbed with forklift
                                </Option>
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                      ) : (
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span
                                style={{ color: "#7B8190", fontSize: "14px" }}
                              >
                                Type of Truck
                              </span>
                            }
                          >
                            {getFieldDecorator("deliveryTruck", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Type of Truck!",
                                },
                              ],
                            })(
                              <Select
                                placeholder={"Delivery Truck"}
                                style={{ width: "100%" }}
                                mode="multiple"
                              >
                                <Option value="Tractor Trailer">
                                  Tractor Trailer
                                </Option>
                                <Option value="Dump Truck/Triaxle">
                                  Dump Truck/Triaxle
                                </Option>
                                <Option value="Mason Dump">Mason Dump</Option>
                                <Option value="OpenTop">
                                  Open Top Hopper Railcar
                                </Option>
                                <Option value="GondolaRailcar">
                                  Gondola Railcar
                                </Option>
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                      )}

                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          className="Formitem"
                          label={<span className="label">Price</span>}
                        >
                          {getFieldDecorator("amount", {
                            initialValue: "",
                            rules: [
                              {
                                required: true,
                                message: "Please input Price!",
                              },
                            ],
                          })(<Input />)}
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </FormItem>
              </Modal>
            </Form>

            <Modal
              visible={confirmModal}
              closable={true}
              footer={[
                <Button
                  key="cancel"
                  className="cancel"
                  onClick={() => {
                    this.setState({ confirmModal: false });
                  }}
                >
                  Cancel
                </Button>,
                <Button
                  type="primary"
                  key="editSubmit"
                  htmlType="submit"
                  loading={dataLoadingStatus}
                  onClick={() => {
                    this.orderConfirm("new");
                  }}
                >
                  Confirm Location
                </Button>,
              ]}
            >
              <div>
                <Row>
                  <CloseOutlined
                    onClick={() => {
                      this.setState({ confirmModal: false });
                    }}
                    style={{
                      float: "right",
                      cursor: "pointer",
                      fontSize: "1.4em",
                    }}
                  />

                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span className="label">Confirm Pickup Location</span>
                      }
                    >
                      {getFieldDecorator("confirmPickupLocation", {
                        rules: [
                          {
                            required: true,
                            message: "Please select pickup location",
                          },
                        ],
                        initialValue:
                          leadData["productOriginDetails"] &&
                          leadData["productOriginDetails"]["locationName"]
                            ? leadData["productOriginDetails"]["id"]
                            : "",
                      })(
                        <Select
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Please Select"
                          showArrow
                        >
                          {productLocations
                            ?.sort((a, b) =>
                              a["locationName"] > b["locationName"] ? 1 : -1
                            )
                            .map((loc) => (
                              <Option value={loc.id} key={loc.id}>
                                {loc.locationName}
                              </Option>
                            ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Modal>
          </div>

          <Form>
            <Modal
              visible={rateModal}
              closable={true}
              footer={[
                <Button
                  key="cancel"
                  className="cancel"
                  onClick={this.closeRateModel}
                >
                  Cancel
                </Button>,
                <Button
                  type="primary"
                  key="editSubmit"
                  htmlType="submit"
                  loading={loading}
                  onClick={this.pushToCarriers}
                >
                  Update
                </Button>,
              ]}
            >
              <div>
                <Row>
                  <Col
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{ textAlign: "right" }}
                  >
                    <CloseOutlined
                      onClick={this.closeRateModel}
                      style={{
                        float: "right",
                        cursor: "pointer",
                        fontSize: "1.4em",
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      label={
                        <span style={{ color: "#7B8190" }}>
                          What's the Rate?
                        </span>
                      }
                    >
                      {getFieldDecorator("callForRate", {
                        initialValue: leadData["callForRate"],
                      })(
                        <Checkbox
                          style={{}}
                          checked={callForRateValue}
                          onChange={() => {
                            this.setState({
                              callForRateValue: !callForRateValue,
                            });
                          }}
                        >
                          Call for Rate
                        </Checkbox>
                      )}
                    </Form.Item>
                  </Col>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item>
                      {getFieldDecorator("rateValue", {
                        initialValue: leadData["rateAmt"],
                      })(
                        <Input
                          placeholder="Rate"
                          disabled={getFieldValue("callForRate")}
                          addonBefore="$"
                          style={{ width: "95%" }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item className="Formitem">
                      {getFieldDecorator("rateOption", {
                        initialValue: leadData["rateOption"],
                      })(
                        <Radio.Group disabled={getFieldValue("callForRate")}>
                          <Radio style={radioStyle} value={"ton"}>
                            Ton
                          </Radio>
                          <Radio style={radioStyle} value={"flat"}>
                            Flat Rate
                          </Radio>
                        </Radio.Group>
                      )}
                    </Form.Item>
                    <span style={{ color: "red" }}>{rateErrorMsg}</span>
                  </Col>
                </Row>
              </div>
            </Modal>
          </Form>
        </Spin>

        <Form>
          <Modal
            title="Delivery Confirmation"
            visible={showDeliveryModal}
            className="modal-black-close"
            onCancel={() => {
              this.props.form.setFieldsValue({
                ticketNumber: "",
                gWeight: "",
                tWeight: "",
              });

              this.setState({
                showDeliveryModal: false,
                loading: false,
                imageUrl3: "",
                imageUrl4: "",
              });
            }}
            footer={[
              <Button
                key="cancel"
                className="cancel"
                onClick={() => {
                  this.props.form.setFieldsValue({
                    ticketNumber: "",
                    gWeight: "",
                    tWeight: "",
                  });

                  this.setState({
                    showDeliveryModal: false,
                    loading: false,
                    imageUrl3: "",
                    imageUrl4: "",
                  });
                }}
              >
                Cancel
              </Button>,
              <Button
                type="primary"
                key="editSubmit"
                htmlType="submit"
                loading={this.state.loading}
                onClick={this.onFinish}
              >
                Load Delivered
              </Button>,
            ]}
            width={"35%"}
          >
            <div>
              <Row>
                <Row>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Delivery Date</span>}
                    >
                      {getFieldDecorator("deliveryDate", {
                        rules: [
                          {
                            required: true,
                            message: "Please input delivery date",
                          },
                        ],
                        initialValue: moment(),
                      })(
                        <DatePicker
                          format="MM/DD/YYYY"
                          disabledDate={(current) => {
                            return (
                              current && current < moment().subtract(1, "days")
                            );
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Delivery Time</span>}
                    >
                      {getFieldDecorator("deliveryTime", {
                        rules: [
                          {
                            required: true,
                            message: "Please input delivery time",
                          },
                        ],
                        initialValue: moment(),
                      })(
                        <TimePicker
                          placeholder="Delivery Time"
                          use12Hours
                          minuteStep={15}
                          showSecond={false}
                          focusOnOpen={true}
                          format="hh:mm A"
                          onChange={this.onChangeTime}
                          className="time-picker"
                          defaultValue={moment()}
                          style={{ width: "100%" }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Ticket Number</span>}
                    >
                      {getFieldDecorator("ticketNumber", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your Ticket Number!",
                          },
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>

                  <Col lg={11} md={11} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Gross Weight</span>}
                    >
                      {getFieldDecorator("gWeight", {
                        rules: [
                          {
                            required: true,
                            message: "Please input the gross weight!",
                          },
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>

                  <Col
                    lg={{ span: 11, offset: 2 }}
                    md={{ span: 11, offset: 2 }}
                    sm={24}
                    xs={24}
                  >
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Tare Weight</span>}
                    >
                      {getFieldDecorator("tWeight", {
                        rules: [
                          {
                            required: true,
                            message: "Please input the tare weight!",
                          },
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col
                    xl={{ span: 6 }}
                    lg={{ span: 12 }}
                    md={{ span: 12 }}
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                  >
                    <Form.Item
                      label={
                        <span className="label">Image of written ticket</span>
                      }
                      className="form-item-mobile"
                    >
                      <Spin spinning={uploadPicLoading3}>
                        {imageUrl3 !== "" && imageUrl3 !== undefined && (
                          <Col span={18}>
                            <DeleteOutlined
                              className="delete_Outlined"
                              onClick={() =>
                                this.haandleDeleteImages(
                                  "_delivery_ticket_pic_"
                                )
                              }
                            />
                          </Col>
                        )}
                        <Col span={24}>
                          <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader-carrier"
                            style={{
                              borderRadius: "50%",
                              width: "100%",
                              height: "100%",
                            }}
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            onChange={(e) =>
                              this.handleUploadPic(e, "_delivery_ticket_pic_")
                            }
                          >
                            {imageUrl3 ? (
                              <img
                                src={`https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/${imageUrl3}`}
                                alt="avatar"
                                style={{ width: "100px", height: "100%" }}
                              />
                            ) : (
                              <CameraOutlined className="camera-icon-carrier" />
                            )}
                          </Upload>
                        </Col>
                      </Spin>
                    </Form.Item>
                  </Col>

                  <Col
                    xl={{ span: 6 }}
                    lg={{ span: 12 }}
                    md={{ span: 12 }}
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                  >
                    <Form.Item
                      label={<span className="label">Image of delivery</span>}
                      className="form-item-mobile"
                    >
                      <Spin spinning={uploadPicLoading4}>
                        {imageUrl4 !== "" && imageUrl4 !== undefined && (
                          <Col span={18}>
                            <DeleteOutlined
                              className="delete_Outlined"
                              onClick={() =>
                                this.haandleDeleteImages("_delivery_pic_")
                              }
                            />
                          </Col>
                        )}
                        <Col span={24}>
                          <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader-carrier"
                            style={{
                              borderRadius: "50%",
                              width: "100%",
                              height: "100%",
                            }}
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            onChange={(e) =>
                              this.handleUploadPic(e, "_delivery_pic_")
                            }
                          >
                            {imageUrl4 ? (
                              <img
                                src={`https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/${imageUrl4}`}
                                alt="avatar"
                                style={{ width: "100px", height: "100%" }}
                              />
                            ) : (
                              <CameraOutlined className="camera-icon-carrier" />
                            )}
                          </Upload>
                        </Col>
                      </Spin>
                    </Form.Item>
                  </Col>
                </Row>
              </Row>
            </div>
          </Modal>
        </Form>
        <Form>
          <Modal
            visible={this.state.bolModal}
            title={""}
            onOk={this.confirm}
            onCancel={() => {
              this.setState({ bolModal: false });
            }}
            footer={[
              <Button
                key="back"
                className="cancel"
                onClick={() => {
                  this.props.form.resetFields();
                  this.setState({ bolModal: false });
                }}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                className="assigning"
                loading={this.state.sendMailloading}
                onClick={this.sendBOL}
              >
                Save
              </Button>,
            ]}
          >
            <Row>
              <Form.Item
                className="Formitem"
                label={<span style={{ color: "#0E4D90" }}>Email</span>}
              >
                {getFieldDecorator("emails", {
                  rules: [
                    {
                      required: true,
                      message: "Please select email",
                    },
                  ],
                })(
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Please Select email"
                    showArrow
                  >
                    {this.state.allUserList.map((alluser) => (
                      <Option value={alluser.email} key={alluser.id}>
                        {alluser.email}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Row>
          </Modal>
        </Form>
      </div>
    );
  }
}

export default Form.create({ name: "loadDetails" })(
  withAppContext(withRouter(LoadDetails))
);
